import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { Observable, Subscription, of, throwError } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Modalite, ModalitesService } from '../core/modalites.service';
import { AlertesService } from '../shared/alertes.service';
import { variableIdentifiante } from '../shared/questionnaire.metadata';
import { ValidationService } from '../shared/validation/validation.service';


@Injectable({
  providedIn: 'root'
})
export class SaisieService {
  private url: string;

  public bavtotAaNbAav: number;
  public bavtotAaNbJur: number;
  public bavtotAaNbPsy: number;
  public bavtotAaNbWsoc: number;
  public bavtotAaNbAutrInterv: number;
  public bavtotAaNbDir: number;
  public bavtotAaNbComptsecr: number;
  public bavtotAaNbAutrSupport: number;
  public bavtotAaNbTot: number;

  public bavtotAaEtpAav_number: number;
  public bavtotAaEtpJur_number: number;
  public bavtotAaEtpPsy_number: number;
  public bavtotAaEtpWsoc_number: number;
  public bavtotAaEtpAutrInterv_number: number;
  public bavtotAaEtpDir_number: number;
  public bavtotAaEtpComptsecr_number: number;
  public bavtotAaEtpAutrSupport_number: number;
  public bavtotAaEtpTot_number: number;
  public bavtotAaEtpAav: string;
  public bavtotAaEtpJur: string;
  public bavtotAaEtpPsy: string;
  public bavtotAaEtpWsoc: string;
  public bavtotAaEtpAutrInterv: string;
  public bavtotAaEtpDir: string;
  public bavtotAaEtpComptsecr: string;
  public bavtotAaEtpAutrSupport: string;
  public bavtotAaEtpTot: string;

  public bavtotBbPremContactOrigAsso: number;
  public bavtotBbPremContactOrigPerso: number;
  public bavtotBbPremContactOrigTot: number;
  public bavtotBbPremContactModeEcrit: number;
  public bavtotBbPremContactModeTel: number;
  public bavtotBbPremContactModePres: number;
  public bavtotBbPremContactModeTot: number;
  public bavtotCcRecuVictNb: number;
  public bavtotCcRecuVictSuivi: number;
  public bavtotCcRecuVictEntret: number;
  public bavtotCcRecuNvictNb: number;
  public bavtotCcRecuNvictSuivi: number;
  public bavtotCcRecuNvictEntret: number;
  public bavtotCcRecuNbTot: number;
  public bavtotCcRecuSuiviTot: number;
  public bavtotCcRecuEntretTot: number;
  public bavtotCcRecuVict: number;
  public bavtotCcRecuVictPc: number;
  public bavtotCcRecuVictAud: number;
  public bavtotDdFaitPersoHomiVolo: number;
  public bavtotDdFaitPersoSexuel: number;
  public bavtotDdFaitPersoProxe: number;
  public bavtotDdFaitPersoViolen: number;
  public bavtotDdFaitPersoHomiInvolo: number;
  public bavtotDdFaitPersoBless: number;
  public bavtotDdFaitPersoAband: number;
  public bavtotDdFaitPersoMenace: number;
  public bavtotDdFaitPersoDiscri: number;
  public bavtotDdFaitPersoAutr: number;
  public bavtotDdFaitPersoTot: number;
  public bavtotDdFaitBienVolSimp: number;
  public bavtotDdFaitBienVolAggr: number;
  public bavtotDdFaitBienEscro: number;
  public bavtotDdFaitBienDegrad: number;
  public bavtotDdFaitBienAutr: number;
  public bavtotDdFaitBienTot: number;
  public bavtotDdFaitCircuBless: number;
  public bavtotDdFaitCircuDegat: number;
  public bavtotDdFaitCircuTot: number;
  public bavtotDdFaitAutr: number;
  public bavtotDdFaitTot: number;
  public bavtotEeEntretPsy: number;
  public bavtotEeEntretJur: number;
  public bavtotEeEntretSoc: number;
  public bavtotEeEntretEcout: number;
  public bavtotEeEntretAutr: number;
  public bavtotEeEntretTot: number;
  public bavtotEeDiliJur: number;
  public bavtotEeDiliCivi: number;
  public bavtotEeDiliFondGaran: number;
  public bavtotEeDiliSarvi: number;
  public bavtotEeDiliPenit: number;
  public bavtotEeDiliPolgend: number;
  public bavtotEeDiliAvoc: number;
  public bavtotEeDiliHuis: number;
  public bavtotEeDiliOrgaSoc: number;
  public bavtotEeDiliColter: number;
  public bavtotEeDiliPref: number;
  public bavtotEeDiliOrgaLogt: number;
  public bavtotEeDiliHebgt: number;
  public bavtotEeDiliHosto: number;
  public bavtotEeDiliAsso: number;
  public bavtotEeDiliAssur: number;
  public bavtotEeDiliSad: number;
  public bavtotEeDiliFrserv: number;
  public bavtotEeDiliAutr: number;
  public bavtotEeDiliTot: number;
  public bavtotEeAideCivi: number;
  public bavtotEeAideSarvi: number;
  public bavtotEeProcPreSentenPlainte: number;
  public bavtotEeProcPreSentenEnq: number;
  public bavtotEeProcPreSentenCss: number;
  public bavtotEeProcPreSentenPc: number;
  public bavtotEeProcPreSentenAud: number;
  public bavtotEeProcPreSentenAutr: number;
  public bavtotEeProcPreSentenTot: number;
  public bavtotEeProcPostSentenDec: number;
  public bavtotEeProcPostSentenDef: number;
  public bavtotEeProcPostSentenRecour: number;
  public bavtotEeProcPostSentenAutr: number;
  public bavtotEeProcPostSentenTot: number;
  public bavtotEeAuteurPreSentenCj: number;
  public bavtotEeAuteurPreSentenDp: number;
  public bavtotEeAuteurPreSentenFinDeten: number;
  public bavtotEeAuteurPreSentenFinMes: number;
  public bavtotEeAuteurPreSentenAutr: number;
  public bavtotEeAuteurPreSentenTot: number;
  public bavtotEeAuteurPostSentenMilFer: number;
  public bavtotEeAuteurPostSentenMilOuv: number;
  public bavtotEeAuteurPostSentenFinDeten: number;
  public bavtotEeAuteurPostSentenFinMes: number;
  public bavtotEeAuteurPostSentenAutr: number;
  public bavtotEeAuteurPostSentenTot: number;
  public bavtotEeDiPreSentenCivi: number;
  public bavtotEeDiPreSentenAutr: number;
  public bavtotEeDiPreSentenTot: number;
  public bavtotEeDiPostSentenCivi: number;
  public bavtotEeDiPostSentenSarvi: number;
  public bavtotEeDiPostSentenHuis: number;
  public bavtotEeDiPostSentenJapSpip: number;
  public bavtotEeDiPostSentenFondGar: number;
  public bavtotEeDiPostSentenAutr: number;
  public bavtotEeDiPostSentenTot: number;
  public bavtotEeFoncJudic: number;
  public bavtotEeDemarPlainte: number;
  public bavtotEeDemarAj: number;
  public bavtotEeDemarAud: number;
  public bavtotEeDemarAccomp: number;
  public bavtotEeDemarDi: number;
  public bavtotEeDemarAutr: number;
  public bavtotEeDemarTot: number;

  /** Liste des alertes pour l'api */
  public listeAlertesForm: Array<string> = new Array<string>();

  constructor(
    public modaliteService: ModalitesService,
    public validationService: ValidationService,
    private http: HttpClient,
    public alertesService: AlertesService,
    @Inject('API_URL') private apiUrl: string
    ) {
      this.url = apiUrl + '/saisie';
    }
  /**
   * Permet de récupérer la saisie, l’objet servant à communiquer avec le back-end java
   */
  public formulaireToSaisie(rootForm: UntypedFormGroup) {
    const saisie = {};
    Object.assign(saisie, rootForm.value);
    // Si l’on veut récupèrer des informations supplémentaires d’un utilisateur précis
    //Object.assign(saisie, this.getUtilisateurPourEnvoi());
    return saisie;
  }
  /**
   * Envoi la saisie via une requête put
   * @param saisie le questionnaire en objet JS
   * @param valid permet de savoir si le questionnaire est valide
   */
  public putSaisie$(saisie: any, valid: boolean): Observable<any> {
    let urlFinale = this.url;
    variableIdentifiante.forEach((nomVariable) => {
      urlFinale += '/' + saisie[nomVariable];
    });
    urlFinale += '?validation=' + valid;
    return this.http.put(urlFinale, saisie);
  }
  /**
   * Envoi la saisie via une requête post
   * @param saisie le questionnaire en objet JS
   * @param valid permet de savoir si le questionnaire est valide
   */
  public postSaisie$(saisie: any, valid: boolean): Observable<any> {
    return this.http.post(this.url + '?validation=' + valid /*+ saisie[variableIdentifiante] + '/'*/, saisie);
  }
  /**
   * Envoi la saisie via une requête post
   * @param saisie l’identifiant du questionnaire à supprimer
   */
  public delSaisie$(identifiants: string[]): Observable<any> {
    if (identifiants !== null) {
      let urlFinale = this.url;
      identifiants.forEach((identifiant) => {
        urlFinale += '/' + identifiant;
      });
      return this.http.delete(urlFinale);
    }
  }
  /**
   * Fonction pour récupérer le questionnaire depuis le serveur Java.
   * @param valeurIdentifiant Valeur permettant de récupèrer le bon questionnaire
   */
  public getSaisieJava$(valeurIdentifiant: string[]): Observable<any> {
    let urlFinale = this.url;
    valeurIdentifiant.forEach((valeur) => {
      urlFinale += '/' + valeur;
    });
    return this.http.get(urlFinale)
      .pipe(catchError((erreur: any) => {
        // inspiré de https://www.positronx.io/angular-7-httpclient-http-service/
        let messageErreur = '';
        if (erreur.error instanceof ErrorEvent) {
          messageErreur = erreur.error.message;
        } else {
          if (erreur.status === 404) {
            // Pour cette requête précise, on renvoit un questionnaire vide :) !
            return of({});
          } else if (erreur.status === 400) {
            // utilisé pour Squat, permet de préciser quelle juridiction utilise déjà un numéro de compostage
            alert(erreur.headers.get('noCmpst'));
            return of({ko: true});
          }
          // Erreur provenant du serveur
          messageErreur = `Code d’erreur : ${erreur.status}\nMessage: ${erreur.message}`;
        }
        return throwError(messageErreur);
      }));

  }
  /**
   * Fonction permettant de récupérer des informations pouvant être utile depuis l’annuaire
   *! On ne s’en sert pas vraiment actuellement, juste au besoin
   */

  public isNumeroDejaPris(numero: number) {
    return this.http.get(this.apiUrl + '/test_numero/' + numero);
  }

/** Permet de renseigner libelleJuridiction en fonction de l’identifiantJuridiction passé en paramètre */
public gestionLibelle(identifiantJuridiction: string, modalites: Modalite[]): string {
  let libelle: string = '';
  // Si le champ est vide on remet à zéro le libellé affiché
  if (identifiantJuridiction === '') {
    libelle = '';
  } else {
    // recherche de la modalité à afficher
    modalites.forEach(modalite => {
      if (modalite.code === identifiantJuridiction) {
        libelle = modalite.libelle;
      }
    });
  }
  return libelle;
}


// Fonctions qui permettent de faire les calculs de totaux automatiques sur bouton
public calculTotal2(formulaire: UntypedFormGroup, idTot: string, idChamp1: string, idChamp2: string): void {
    
    let total1: number; 
    let total2: number; 
    let total: number; 
    
      if (formulaire.get(idChamp1).value !== null) {
        total1 = formulaire.get(idChamp1).value;
      } else {
        total1 = 0;
      }
      if (formulaire.get(idChamp2).value !== null) {
        total2 =  formulaire.get(idChamp2).value;
      } else {
        total2 = 0;
      }

      total = total1 + total2;

      if (total !== 0) {
        formulaire.get(idTot).setValue(total);
      } else {
          // le total ramene 0 : soit les champs sont non renseignes soit à 0
          // on test qu'une valeur n'est pas renseignée pour remettre total à null sinon on laisse 0
          if ((formulaire.get(idChamp1).value=== null)
          && (formulaire.get(idChamp2).value === null)
          ) {
              formulaire.get(idTot).setValue(null);
          } else {
              formulaire.get(idTot).setValue(total);
          }
      }          
}

public calculTotal3(formulaire: UntypedFormGroup, idTot: string, idChamp1: string, idChamp2: string, idChamp3: string): void {
    
  let total1: number; 
  let total2: number; 
  let total3: number; 
  let total: number; 
  
    if (formulaire.get(idChamp1).value !== null) {
      total1 = formulaire.get(idChamp1).value;
    } else {
      total1 = 0;
    }
    if (formulaire.get(idChamp2).value !== null) {
      total2 =  formulaire.get(idChamp2).value;
    } else {
      total2 = 0;
    }
    if (formulaire.get(idChamp3).value !== null) {
      total3 =  formulaire.get(idChamp3).value;
    } else {
      total3 = 0;
    }

    total = total1 + total2 + total3;

    if (total !== 0) {
      formulaire.get(idTot).setValue(total);
    } else {
        // le total ramene 0 : soit les champs sont non renseignes soit à 0
        // on test qu'une valeur n'est pas renseignée pour remettre total à null sinon on laisse 0
        if ((formulaire.get(idChamp1).value=== null)
        && (formulaire.get(idChamp2).value === null)
        && (formulaire.get(idChamp3).value === null)
        ) {
            formulaire.get(idTot).setValue(null);
        } else {
            formulaire.get(idTot).setValue(total);
        }
    }          
}

public calculTotal4(formulaire: UntypedFormGroup, idTot: string, idChamp1: string, idChamp2: string, idChamp3: string, idChamp4: string): void {
    
  let total1: number; 
  let total2: number; 
  let total3: number; 
  let total4: number; 
  let total: number; 
  
    if (formulaire.get(idChamp1).value !== null) {
      total1 = formulaire.get(idChamp1).value;
    } else {
      total1 = 0;
    }
    if (formulaire.get(idChamp2).value !== null) {
      total2 =  formulaire.get(idChamp2).value;
    } else {
      total2 = 0;
    }
    if (formulaire.get(idChamp3).value !== null) {
      total3 =  formulaire.get(idChamp3).value;
    } else {
      total3 = 0;
    }
    if (formulaire.get(idChamp4).value !== null) {
      total4 =  formulaire.get(idChamp4).value;
    } else {
      total4 = 0;
    }

    total = total1 + total2 + total3 + total4;

    if (total !== 0) {
      formulaire.get(idTot).setValue(total);
    } else {
        // le total ramene 0 : soit les champs sont non renseignes soit à 0
        // on test qu'une valeur n'est pas renseignée pour remettre total à null sinon on laisse 0
        if ((formulaire.get(idChamp1).value=== null)
        && (formulaire.get(idChamp2).value === null)
        && (formulaire.get(idChamp3).value === null)
        && (formulaire.get(idChamp4).value === null)
        ) {
            formulaire.get(idTot).setValue(null);
        } else {
            formulaire.get(idTot).setValue(total);
        }
    }          
}

public calculTotal5(formulaire: UntypedFormGroup, idTot: string, idChamp1: string, idChamp2: string, idChamp3: string, idChamp4: string, idChamp5: string): void {
    
  let total1: number; 
  let total2: number; 
  let total3: number; 
  let total4: number; 
  let total5: number; 
  let total: number; 
  
    if (formulaire.get(idChamp1).value !== null) {
      total1 = formulaire.get(idChamp1).value;
    } else {
      total1 = 0;
    }
    if (formulaire.get(idChamp2).value !== null) {
      total2 =  formulaire.get(idChamp2).value;
    } else {
      total2 = 0;
    }
    if (formulaire.get(idChamp3).value !== null) {
      total3 =  formulaire.get(idChamp3).value;
    } else {
      total3 = 0;
    }
    if (formulaire.get(idChamp4).value !== null) {
      total4 =  formulaire.get(idChamp4).value;
    } else {
      total4 = 0;
    }
    if (formulaire.get(idChamp5).value !== null) {
      total5 =  formulaire.get(idChamp5).value;
    } else {
      total5 = 0;
    }

    total = total1 + total2 + total3 + total4 + total5;

    if (total !== 0) {
      formulaire.get(idTot).setValue(total);
    } else {
        // le total ramene 0 : soit les champs sont non renseignes soit à 0
        // on test qu'une valeur n'est pas renseignée pour remettre total à null sinon on laisse 0
        if ((formulaire.get(idChamp1).value=== null)
        && (formulaire.get(idChamp2).value === null)
        && (formulaire.get(idChamp3).value === null)
        && (formulaire.get(idChamp4).value === null)
        && (formulaire.get(idChamp5).value === null)
        ) {
            formulaire.get(idTot).setValue(null);
        } else {
            formulaire.get(idTot).setValue(total);
        }
    }          
}

public calculTotal7(formulaire: UntypedFormGroup, idTot: string, idChamp1: string, idChamp2: string, idChamp3: string, idChamp4: string, idChamp5: string, idChamp6: string,
    idChamp7: string): void {
  
          let total1: number; 
          let total2: number; 
          let total3: number; 
          let total4: number; 
          let total5: number; 
          let total6: number; 
          let total7: number; 
          let total: number; 
          
            if (formulaire.get(idChamp1).value !== null) {
              total1 = formulaire.get(idChamp1).value;
            } else {
              total1 = 0;
            }
            if (formulaire.get(idChamp2).value !== null) {
              total2 =  formulaire.get(idChamp2).value;
            } else {
              total2 = 0;
            }
            if (formulaire.get(idChamp3).value !== null) {
              total3 =  formulaire.get(idChamp3).value;
            } else {
              total3 = 0;
            }
            if (formulaire.get(idChamp4).value !== null) {
              total4 =  formulaire.get(idChamp4).value;
            } else {
              total4 = 0;
            }
            if (formulaire.get(idChamp5).value !== null) {
              total5 =  formulaire.get(idChamp5).value;
            } else {
              total5 = 0;
            }
            if (formulaire.get(idChamp6).value !== null) {
              total6 =  formulaire.get(idChamp6).value;
            } else {
              total6 = 0;
            }
            if (formulaire.get(idChamp7).value !== null) {
              total7 =  formulaire.get(idChamp7).value;
            } else {
              total7 = 0;
            }
  
            total = total1 + total2 + total3 + total4 + total5 + total6 + total7;
  
            if (total !== 0) {
              formulaire.get(idTot).setValue(total);
            } else {
                // le total ramene 0 : soit les champs sont non renseignes soit à 0
                // on test qu'une valeur n'est pas renseignée pour remettre total à null sinon on laisse 0
                if ((formulaire.get(idChamp1).value=== null)
                && (formulaire.get(idChamp2).value === null)
                && (formulaire.get(idChamp3).value === null)
                && (formulaire.get(idChamp4).value === null)
                && (formulaire.get(idChamp5).value === null)
                && (formulaire.get(idChamp6).value === null)
                && (formulaire.get(idChamp7).value === null)
                ) {
                    formulaire.get(idTot).setValue(null);
                } else {
                    formulaire.get(idTot).setValue(total);
                }
            }          
}

public calculTotal8(formulaire: UntypedFormGroup, idTot: string, idChamp1: string, idChamp2: string, idChamp3: string, idChamp4: string, idChamp5: string, idChamp6: string,
  idChamp7: string, idChamp8: string, indic_decimal: boolean): void {

        // on met any car cela peut être un number ou un decimal!
        let total1: any; 
        let total2: any; 
        let total3: any; 
        let total4: any; 
        let total5: any; 
        let total6: any; 
        let total7: any; 
        let total8: any; 
        let total: any; 
        
          if (formulaire.get(idChamp1).value !== null) {
            total1 = formulaire.get(idChamp1).value;
          } else {
            total1 = 0;
          }
          if (formulaire.get(idChamp2).value !== null) {
            total2 =  formulaire.get(idChamp2).value;
          } else {
            total2 = 0;
          }
          if (formulaire.get(idChamp3).value !== null) {
            total3 =  formulaire.get(idChamp3).value;
          } else {
            total3 = 0;
          }
          if (formulaire.get(idChamp4).value !== null) {
            total4 =  formulaire.get(idChamp4).value;
          } else {
            total4 = 0;
          }
          if (formulaire.get(idChamp5).value !== null) {
            total5 =  formulaire.get(idChamp5).value;
          } else {
            total5 = 0;
          }
          if (formulaire.get(idChamp6).value !== null) {
            total6 =  formulaire.get(idChamp6).value;
          } else {
            total6 = 0;
          }
          if (formulaire.get(idChamp7).value !== null) {
            total7 =  formulaire.get(idChamp7).value;
          } else {
            total7 = 0;
          }
          if (formulaire.get(idChamp8).value !== null) {
            total8 =  formulaire.get(idChamp8).value;
          } else {
            total8 = 0;
          }

          total = total1 + total2 + total3 + total4 + total5 + total6 + total7 + total8;

          if (total !== 0) {
            // on teste si le total est sur des nombres decimaux et il faut forcer dans ces cas là au format à 2 décimales!
            if (indic_decimal === true) {
              total = parseFloat(parseFloat(total).toFixed(2));
            }

            formulaire.get(idTot).setValue(total);
          } else {
              // le total ramene 0 : soit les champs sont non renseignes soit à 0
              // on test qu'une valeur n'est pas renseignée pour remettre total à null sinon on laisse 0
              if ((formulaire.get(idChamp1).value=== null)
              && (formulaire.get(idChamp2).value === null)
              && (formulaire.get(idChamp3).value === null)
              && (formulaire.get(idChamp4).value === null)
              && (formulaire.get(idChamp5).value === null)
              && (formulaire.get(idChamp6).value === null)
              && (formulaire.get(idChamp7).value === null)
              && (formulaire.get(idChamp8).value === null)
              ) {
                  formulaire.get(idTot).setValue(null);
              } else {
                  formulaire.get(idTot).setValue(total);
              }
          }          
}

public calculTotal10(formulaire: UntypedFormGroup, idTot: string, idChamp1: string, idChamp2: string, idChamp3: string, idChamp4: string, idChamp5: string, idChamp6: string,
  idChamp7: string, idChamp8: string, idChamp9: string, idChamp10: string): void {

        let total1: number; 
        let total2: number; 
        let total3: number; 
        let total4: number; 
        let total5: number; 
        let total6: number; 
        let total7: number; 
        let total8: number; 
        let total9: number; 
        let total10: number; 
        let total: number; 
        
          if (formulaire.get(idChamp1).value !== null) {
            total1 = formulaire.get(idChamp1).value;
          } else {
            total1 = 0;
          }
          if (formulaire.get(idChamp2).value !== null) {
            total2 =  formulaire.get(idChamp2).value;
          } else {
            total2 = 0;
          }
          if (formulaire.get(idChamp3).value !== null) {
            total3 =  formulaire.get(idChamp3).value;
          } else {
            total3 = 0;
          }
          if (formulaire.get(idChamp4).value !== null) {
            total4 =  formulaire.get(idChamp4).value;
          } else {
            total4 = 0;
          }
          if (formulaire.get(idChamp5).value !== null) {
            total5 =  formulaire.get(idChamp5).value;
          } else {
            total5 = 0;
          }
          if (formulaire.get(idChamp6).value !== null) {
            total6 =  formulaire.get(idChamp6).value;
          } else {
            total6 = 0;
          }
          if (formulaire.get(idChamp7).value !== null) {
            total7 =  formulaire.get(idChamp7).value;
          } else {
            total7 = 0;
          }
          if (formulaire.get(idChamp8).value !== null) {
            total8 =  formulaire.get(idChamp8).value;
          } else {
            total8 = 0;
          }
          if (formulaire.get(idChamp9).value !== null) {
            total9 =  formulaire.get(idChamp9).value;
          } else {
            total9 = 0;
          }
          if (formulaire.get(idChamp10).value !== null) {
            total10 =  formulaire.get(idChamp10).value;
          } else {
            total10 = 0;
          }

          total = total1 + total2 + total3 + total4 + total5 + total6 + total7 + total8 + total9 + total10;

          if (total !== 0) {
            formulaire.get(idTot).setValue(total);
          } else {
              // le total ramene 0 : soit les champs sont non renseignes soit à 0
              // on test qu'une valeur n'est pas renseignée pour remettre total à null sinon on laisse 0
              if ((formulaire.get(idChamp1).value=== null)
              && (formulaire.get(idChamp2).value === null)
              && (formulaire.get(idChamp3).value === null)
              && (formulaire.get(idChamp4).value === null)
              && (formulaire.get(idChamp5).value === null)
              && (formulaire.get(idChamp6).value === null)
              && (formulaire.get(idChamp7).value === null)
              && (formulaire.get(idChamp8).value === null)
              && (formulaire.get(idChamp9).value === null)
              && (formulaire.get(idChamp10).value === null)
              ) {
                  formulaire.get(idTot).setValue(null);
              } else {
                  formulaire.get(idTot).setValue(total);
              }
          }          
}

public calculTotal15(formulaire: UntypedFormGroup, idTot: string, idChamp1: string, idChamp2: string, idChamp3: string, idChamp4: string, idChamp5: string, idChamp6: string,
  idChamp7: string, idChamp8: string, idChamp9: string, idChamp10: string, idChamp11: string, idChamp12: string, idChamp13: string, idChamp14: string, idChamp15: string): void {

        let total1: number; 
        let total2: number; 
        let total3: number; 
        let total4: number; 
        let total5: number; 
        let total6: number; 
        let total7: number; 
        let total8: number; 
        let total9: number; 
        let total10: number; 
        let total11: number; 
        let total12: number; 
        let total13: number; 
        let total14: number; 
        let total15: number; 
        let total: number; 
        
          if (formulaire.get(idChamp1).value !== null) {
            total1 = formulaire.get(idChamp1).value;
          } else {
            total1 = 0;
          }
          if (formulaire.get(idChamp2).value !== null) {
            total2 =  formulaire.get(idChamp2).value;
          } else {
            total2 = 0;
          }
          if (formulaire.get(idChamp3).value !== null) {
            total3 =  formulaire.get(idChamp3).value;
          } else {
            total3 = 0;
          }
          if (formulaire.get(idChamp4).value !== null) {
            total4 =  formulaire.get(idChamp4).value;
          } else {
            total4 = 0;
          }
          if (formulaire.get(idChamp5).value !== null) {
            total5 =  formulaire.get(idChamp5).value;
          } else {
            total5 = 0;
          }
          if (formulaire.get(idChamp6).value !== null) {
            total6 =  formulaire.get(idChamp6).value;
          } else {
            total6 = 0;
          }
          if (formulaire.get(idChamp7).value !== null) {
            total7 =  formulaire.get(idChamp7).value;
          } else {
            total7 = 0;
          }
          if (formulaire.get(idChamp8).value !== null) {
            total8 =  formulaire.get(idChamp8).value;
          } else {
            total8 = 0;
          }
          if (formulaire.get(idChamp9).value !== null) {
            total9 =  formulaire.get(idChamp9).value;
          } else {
            total9 = 0;
          }
          if (formulaire.get(idChamp10).value !== null) {
            total10 =  formulaire.get(idChamp10).value;
          } else {
            total10 = 0;
          }
          if (formulaire.get(idChamp11).value !== null) {
            total11 =  formulaire.get(idChamp11).value;
          } else {
            total11 = 0;
          }
          if (formulaire.get(idChamp12).value !== null) {
            total12 =  formulaire.get(idChamp12).value;
          } else {
            total12 = 0;
          }
          if (formulaire.get(idChamp13).value !== null) {
            total13 =  formulaire.get(idChamp13).value;
          } else {
            total13 = 0;
          }
          if (formulaire.get(idChamp14).value !== null) {
            total14 =  formulaire.get(idChamp14).value;
          } else {
            total14 = 0;
          }
          if (formulaire.get(idChamp15).value !== null) {
            total15 =  formulaire.get(idChamp15).value;
          } else {
            total15 = 0;
          }

          total = total1 + total2 + total3 + total4 + total5 + total6 + total7 + total8 + total9 + total10 + total11 + total12 + total13 + total14 + total15;

          if (total !== 0) {
            formulaire.get(idTot).setValue(total);
          } else {
              // le total ramene 0 : soit les champs sont non renseignes soit à 0
              // on test qu'une valeur n'est pas renseignée pour remettre total à null sinon on laisse 0
              if ((formulaire.get(idChamp1).value=== null)
              && (formulaire.get(idChamp2).value === null)
              && (formulaire.get(idChamp3).value === null)
              && (formulaire.get(idChamp4).value === null)
              && (formulaire.get(idChamp5).value === null)
              && (formulaire.get(idChamp6).value === null)
              && (formulaire.get(idChamp7).value === null)
              && (formulaire.get(idChamp8).value === null)
              && (formulaire.get(idChamp9).value === null)
              && (formulaire.get(idChamp10).value === null)
              && (formulaire.get(idChamp11).value === null)
              && (formulaire.get(idChamp12).value === null)
              && (formulaire.get(idChamp13).value === null)
              && (formulaire.get(idChamp14).value === null)
              && (formulaire.get(idChamp15).value === null)
              ) {
                  formulaire.get(idTot).setValue(null);
              } else {
                  formulaire.get(idTot).setValue(total);
              }
          }          
}

public calculTotal19(formulaire: UntypedFormGroup, idTot: string, idChamp1: string, idChamp2: string, idChamp3: string, idChamp4: string, idChamp5: string, idChamp6: string,
  idChamp7: string, idChamp8: string, idChamp9: string, idChamp10: string, idChamp11: string, idChamp12: string, idChamp13: string, idChamp14: string, idChamp15: string,
  idChamp16: string, idChamp17: string, idChamp18: string, idChamp19: string): void {

        let total1: number; 
        let total2: number; 
        let total3: number; 
        let total4: number; 
        let total5: number; 
        let total6: number; 
        let total7: number; 
        let total8: number; 
        let total9: number; 
        let total10: number; 
        let total11: number; 
        let total12: number; 
        let total13: number; 
        let total14: number; 
        let total15: number; 
        let total16: number; 
        let total17: number; 
        let total18: number; 
        let total19: number; 
        let total: number; 
        
          if (formulaire.get(idChamp1).value !== null) {
            total1 = formulaire.get(idChamp1).value;
          } else {
            total1 = 0;
          }
          if (formulaire.get(idChamp2).value !== null) {
            total2 =  formulaire.get(idChamp2).value;
          } else {
            total2 = 0;
          }
          if (formulaire.get(idChamp3).value !== null) {
            total3 =  formulaire.get(idChamp3).value;
          } else {
            total3 = 0;
          }
          if (formulaire.get(idChamp4).value !== null) {
            total4 =  formulaire.get(idChamp4).value;
          } else {
            total4 = 0;
          }
          if (formulaire.get(idChamp5).value !== null) {
            total5 =  formulaire.get(idChamp5).value;
          } else {
            total5 = 0;
          }
          if (formulaire.get(idChamp6).value !== null) {
            total6 =  formulaire.get(idChamp6).value;
          } else {
            total6 = 0;
          }
          if (formulaire.get(idChamp7).value !== null) {
            total7 =  formulaire.get(idChamp7).value;
          } else {
            total7 = 0;
          }
          if (formulaire.get(idChamp8).value !== null) {
            total8 =  formulaire.get(idChamp8).value;
          } else {
            total8 = 0;
          }
          if (formulaire.get(idChamp9).value !== null) {
            total9 =  formulaire.get(idChamp9).value;
          } else {
            total9 = 0;
          }
          if (formulaire.get(idChamp10).value !== null) {
            total10 =  formulaire.get(idChamp10).value;
          } else {
            total10 = 0;
          }
          if (formulaire.get(idChamp11).value !== null) {
            total11 =  formulaire.get(idChamp11).value;
          } else {
            total11 = 0;
          }
          if (formulaire.get(idChamp12).value !== null) {
            total12 =  formulaire.get(idChamp12).value;
          } else {
            total12 = 0;
          }
          if (formulaire.get(idChamp13).value !== null) {
            total13 =  formulaire.get(idChamp13).value;
          } else {
            total13 = 0;
          }
          if (formulaire.get(idChamp14).value !== null) {
            total14 =  formulaire.get(idChamp14).value;
          } else {
            total14 = 0;
          }
          if (formulaire.get(idChamp15).value !== null) {
            total15 =  formulaire.get(idChamp15).value;
          } else {
            total15 = 0;
          }
          if (formulaire.get(idChamp16).value !== null) {
            total16 =  formulaire.get(idChamp16).value;
          } else {
            total16 = 0;
          }
          if (formulaire.get(idChamp17).value !== null) {
            total17 =  formulaire.get(idChamp17).value;
          } else {
            total17 = 0;
          }
          if (formulaire.get(idChamp18).value !== null) {
            total18 =  formulaire.get(idChamp18).value;
          } else {
            total18 = 0;
          }
          if (formulaire.get(idChamp19).value !== null) {
            total19 =  formulaire.get(idChamp19).value;
          } else {
            total19 = 0;
          }

          total = total1 + total2 + total3 + total4 + total5 + total6 + total7 + total8 + total9 + total10 + total11 + total12 + total13 + total14 + total15 + total16 + total17 + total18 + total19;

          if (total !== 0) {
            formulaire.get(idTot).setValue(total);
          } else {
              // le total ramene 0 : soit les champs sont non renseignes soit à 0
              // on test qu'une valeur n'est pas renseignée pour remettre total à null sinon on laisse 0
              if ((formulaire.get(idChamp1).value=== null)
              && (formulaire.get(idChamp2).value === null)
              && (formulaire.get(idChamp3).value === null)
              && (formulaire.get(idChamp4).value === null)
              && (formulaire.get(idChamp5).value === null)
              && (formulaire.get(idChamp6).value === null)
              && (formulaire.get(idChamp7).value === null)
              && (formulaire.get(idChamp8).value === null)
              && (formulaire.get(idChamp9).value === null)
              && (formulaire.get(idChamp10).value === null)
              && (formulaire.get(idChamp11).value === null)
              && (formulaire.get(idChamp12).value === null)
              && (formulaire.get(idChamp13).value === null)
              && (formulaire.get(idChamp14).value === null)
              && (formulaire.get(idChamp15).value === null)
              && (formulaire.get(idChamp16).value === null)
              && (formulaire.get(idChamp17).value === null)
              && (formulaire.get(idChamp18).value === null)
              && (formulaire.get(idChamp19).value === null)
              ) {
                  formulaire.get(idTot).setValue(null);
              } else {
                  formulaire.get(idTot).setValue(total);
              }
          }          
}


// Fonctions de calcul automatiques subscribe
public calculTotal2_detail(formulaire: UntypedFormGroup, subTab: Subscription[], idTot: string, idChamp1: string, idChamp2: string): any {
          
  let total1: number; 
  let total2: number; 
  let total: number; 
  
  subTab.push(formulaire.get(idChamp1).valueChanges.pipe(distinctUntilChanged(), debounceTime(100)).subscribe(valeur => {
    if (valeur !== null) {
      total1 = valeur;
    } else {
      total1 = 0;
    }
    if (formulaire.get(idChamp2).value !== null) {
      total2 =  formulaire.get(idChamp2).value;
    } else {
      total2 = 0;
    }

    total = total1 + total2;

    if (total !== 0) {
      formulaire.get(idTot).setValue(total);
    } else {
        // le total ramene 0 : soit les champs sont non renseignes soit à 0
        // on test qu'une valeur n'est pas renseignée pour remettre total à null sinon on laisse 0
        if ((valeur === null)
        && (formulaire.get(idChamp2).value === null)
        ) {
            formulaire.get(idTot).setValue(null);
        } else {
            formulaire.get(idTot).setValue(total);
        }
    }
  }));
  formulaire.get(idChamp1).updateValueAndValidity();
}

public calculTotal3_detail(formulaire: UntypedFormGroup, subTab: Subscription[], idTot: string, idChamp1: string, idChamp2: string, idChamp3: string): any {
          
  let total1: number; 
  let total2: number; 
  let total3: number; 
  let total: number; 
  
  subTab.push(formulaire.get(idChamp1).valueChanges.pipe(distinctUntilChanged(), debounceTime(100)).subscribe(valeur => {
    if (valeur !== null) {
      total1 = valeur;
    } else {
      total1 = 0;
    }
    if (formulaire.get(idChamp2).value !== null) {
      total2 =  formulaire.get(idChamp2).value;
    } else {
      total2 = 0;
    }
    if (formulaire.get(idChamp3).value !== null) {
      total3 =  formulaire.get(idChamp3).value;
    } else {
      total3 = 0;
    }

    total = total1 + total2 + total3;

    if (total !== 0) {
      formulaire.get(idTot).setValue(total);
    } else {
        // le total ramene 0 : soit les champs sont non renseignes soit à 0
        // on test qu'une valeur n'est pas renseignée pour remettre total à null sinon on laisse 0
        if ((valeur === null)
        && (formulaire.get(idChamp2).value === null)
        && (formulaire.get(idChamp3).value === null)
        ) {
            formulaire.get(idTot).setValue(null);
        } else {
            formulaire.get(idTot).setValue(total);
        }
    }
  }));
  formulaire.get(idChamp1).updateValueAndValidity();
}

public calculTotal9_detail(formulaire: UntypedFormGroup, subTab: Subscription[], idTot: string, idChamp1: string, idChamp2: string, idChamp3: string,
  idChamp4: string, idChamp5: string, idChamp6: string, idChamp7: string, idChamp8: string, idChamp9: string): any {
          
  let total1: number; 
  let total2: number; 
  let total3: number; 
  let total4: number; 
  let total5: number; 
  let total6: number; 
  let total7: number; 
  let total8: number; 
  let total9: number; 
  let total: number; 
  
  subTab.push(formulaire.get(idChamp1).valueChanges.pipe(distinctUntilChanged(), debounceTime(100)).subscribe(valeur => {
    if (valeur !== null) {
      total1 = valeur;
    } else {
      total1 = 0;
    }
    if (formulaire.get(idChamp2).value !== null) {
      total2 =  formulaire.get(idChamp2).value;
    } else {
      total2 = 0;
    }
    if (formulaire.get(idChamp3).value !== null) {
      total3 =  formulaire.get(idChamp3).value;
    } else {
      total3 = 0;
    }
    if (formulaire.get(idChamp4).value !== null) {
      total4 =  formulaire.get(idChamp4).value;
    } else {
      total4 = 0;
    }
    if (formulaire.get(idChamp5).value !== null) {
      total5 =  formulaire.get(idChamp5).value;
    } else {
      total5 = 0;
    }
    if (formulaire.get(idChamp6).value !== null) {
      total6 =  formulaire.get(idChamp6).value;
    } else {
      total6 = 0;
    }
    if (formulaire.get(idChamp7).value !== null) {
      total7 =  formulaire.get(idChamp7).value;
    } else {
      total7 = 0;
    }
    if (formulaire.get(idChamp8).value !== null) {
      total8 =  formulaire.get(idChamp8).value;
    } else {
      total8 = 0;
    }
    if (formulaire.get(idChamp9).value !== null) {
      total9 =  formulaire.get(idChamp9).value;
    } else {
      total9 = 0;
    }

    total = total1 + total2 + total3 + total4 + total5 + total6 + total7 + total8 + total9;

    if (total !== 0) {
      formulaire.get(idTot).setValue(total);
    } else {
        // le total ramene 0 : soit les champs sont non renseignes soit à 0
        // on test qu'une valeur n'est pas renseignée pour remettre total à null sinon on laisse 0
        if ((valeur === null)
        && (formulaire.get(idChamp2).value === null)
        && (formulaire.get(idChamp3).value === null)
        && (formulaire.get(idChamp4).value === null)
        && (formulaire.get(idChamp5).value === null)
        && (formulaire.get(idChamp6).value === null)
        && (formulaire.get(idChamp7).value === null)
        && (formulaire.get(idChamp8).value === null)
        && (formulaire.get(idChamp9).value === null)
        ) {
            formulaire.get(idTot).setValue(null);
        } else {
            formulaire.get(idTot).setValue(total);
        }
    }
  }));
  formulaire.get(idChamp1).updateValueAndValidity();
}


// Calcul des totaux sur bouton mais pour les boucles
public calculTotalBoucle2(detailFormulaire: UntypedFormArray, rang: number, idTot: string, idChamp1: string, idChamp2: string): void {

        let total1: number; 
        let total2: number; 
        let total: number; 

          if (detailFormulaire.controls[rang].get(idChamp1).value === null) {
            total1 = 0;
          } else {
            total1 = detailFormulaire.controls[rang].get(idChamp1).value;
          }
          if (detailFormulaire.controls[rang].get(idChamp2).value === null) {
            total2 = 0;
          } else {
            total2 = detailFormulaire.controls[rang].get(idChamp2).value;
          }

          total = total1 + total2;

          if (total !== 0) {
            detailFormulaire.controls[rang].get(idTot).setValue(total);
          } else {
              // le total ramene 0 : soit les champs sont non renseignes soit à 0
              // on test qu'une valeur n'est pas renseignée pour remettre total à null sinon on laisse 0
              if ((detailFormulaire.controls[rang].get(idChamp1).value === null)
              && (detailFormulaire.controls[rang].get(idChamp2).value === null)
              ) {
                detailFormulaire.controls[rang].get(idTot).setValue(null);
              } else {
                detailFormulaire.controls[rang].get(idTot).setValue(total);
              }
          }          
}

public calculTotalBoucle3(detailFormulaire: UntypedFormArray, rang: number, idTot: string, idChamp1: string, idChamp2: string, idChamp3: string): void {

  let total1: number; 
  let total2: number; 
  let total3: number; 
  let total: number; 

    if (detailFormulaire.controls[rang].get(idChamp1).value === null) {
      total1 = 0;
    } else {
      total1 = detailFormulaire.controls[rang].get(idChamp1).value;
    }
    if (detailFormulaire.controls[rang].get(idChamp2).value === null) {
      total2 = 0;
    } else {
      total2 = detailFormulaire.controls[rang].get(idChamp2).value;
    }
    if (detailFormulaire.controls[rang].get(idChamp3).value === null) {
      total3 = 0;
    } else {
      total3 = detailFormulaire.controls[rang].get(idChamp3).value;
    }

    total = total1 + total2 + total3;

    if (total !== 0) {
      detailFormulaire.controls[rang].get(idTot).setValue(total);
    } else {
        // le total ramene 0 : soit les champs sont non renseignes soit à 0
        // on test qu'une valeur n'est pas renseignée pour remettre total à null sinon on laisse 0
        if ((detailFormulaire.controls[rang].get(idChamp1).value === null)
        && (detailFormulaire.controls[rang].get(idChamp2).value === null)
        && (detailFormulaire.controls[rang].get(idChamp3).value === null)
        ) {
          detailFormulaire.controls[rang].get(idTot).setValue(null);
        } else {
          detailFormulaire.controls[rang].get(idTot).setValue(total);
        }
    }          
}

public calculTotalBoucle4(detailFormulaire: UntypedFormArray, rang: number, idTot: string, idChamp1: string, idChamp2: string, idChamp3: string, idChamp4: string): void {

        let total1: number; 
        let total2: number; 
        let total3: number; 
        let total4: number; 
        let total: number; 

          if (detailFormulaire.controls[rang].get(idChamp1).value === null) {
            total1 = 0;
          } else {
            total1 = detailFormulaire.controls[rang].get(idChamp1).value;
          }
          if (detailFormulaire.controls[rang].get(idChamp2).value === null) {
            total2 = 0;
          } else {
            total2 = detailFormulaire.controls[rang].get(idChamp2).value;
          }
          if (detailFormulaire.controls[rang].get(idChamp3).value === null) {
            total3 = 0;
          } else {
            total3 = detailFormulaire.controls[rang].get(idChamp3).value;
          }
          if (detailFormulaire.controls[rang].get(idChamp4).value === null) {
            total4 = 0;
          } else {
            total4 = detailFormulaire.controls[rang].get(idChamp4).value;
          }

          total = total1 + total2 + total3 + total4;

          if (total !== 0) {
            detailFormulaire.controls[rang].get(idTot).setValue(total);
          } else {
              // le total ramene 0 : soit les champs sont non renseignes soit à 0
              // on test qu'une valeur n'est pas renseignée pour remettre total à null sinon on laisse 0
              if ((detailFormulaire.controls[rang].get(idChamp1).value === null)
              && (detailFormulaire.controls[rang].get(idChamp2).value === null)
              && (detailFormulaire.controls[rang].get(idChamp3).value === null)
              && (detailFormulaire.controls[rang].get(idChamp4).value === null)
              ) {
                detailFormulaire.controls[rang].get(idTot).setValue(null);
              } else {
                detailFormulaire.controls[rang].get(idTot).setValue(total);
              }
          }          
}

public calculTotalBoucle5(detailFormulaire: UntypedFormArray, rang: number, idTot: string, idChamp1: string, idChamp2: string, idChamp3: string, idChamp4: string, idChamp5: string): void {

  let total1: number; 
  let total2: number; 
  let total3: number; 
  let total4: number; 
  let total5: number; 
  let total: number; 

    if (detailFormulaire.controls[rang].get(idChamp1).value === null) {
      total1 = 0;
    } else {
      total1 = detailFormulaire.controls[rang].get(idChamp1).value;
    }
    if (detailFormulaire.controls[rang].get(idChamp2).value === null) {
      total2 = 0;
    } else {
      total2 = detailFormulaire.controls[rang].get(idChamp2).value;
    }
    if (detailFormulaire.controls[rang].get(idChamp3).value === null) {
      total3 = 0;
    } else {
      total3 = detailFormulaire.controls[rang].get(idChamp3).value;
    }
    if (detailFormulaire.controls[rang].get(idChamp4).value === null) {
      total4 = 0;
    } else {
      total4 = detailFormulaire.controls[rang].get(idChamp4).value;
    }
    if (detailFormulaire.controls[rang].get(idChamp5).value === null) {
      total5 = 0;
    } else {
      total5 = detailFormulaire.controls[rang].get(idChamp5).value;
    }

    total = total1 + total2 + total3 + total4 + total5;

    if (total !== 0) {
      detailFormulaire.controls[rang].get(idTot).setValue(total);
    } else {
        // le total ramene 0 : soit les champs sont non renseignes soit à 0
        // on test qu'une valeur n'est pas renseignée pour remettre total à null sinon on laisse 0
        if ((detailFormulaire.controls[rang].get(idChamp1).value === null)
        && (detailFormulaire.controls[rang].get(idChamp2).value === null)
        && (detailFormulaire.controls[rang].get(idChamp3).value === null)
        && (detailFormulaire.controls[rang].get(idChamp4).value === null)
        && (detailFormulaire.controls[rang].get(idChamp5).value === null)
        ) {
          detailFormulaire.controls[rang].get(idTot).setValue(null);
        } else {
          detailFormulaire.controls[rang].get(idTot).setValue(total);
        }
    }          
}

public calculTotalBoucle6(detailFormulaire: UntypedFormArray, rang: number, idTot: string, idChamp1: string, idChamp2: string, 
  idChamp3: string, idChamp4: string, idChamp5: string, idChamp6: string): void {

  let total1: number; 
  let total2: number; 
  let total3: number; 
  let total4: number; 
  let total5: number; 
  let total6: number; 
  let total: number; 

    if (detailFormulaire.controls[rang].get(idChamp1).value === null) {
      total1 = 0;
    } else {
      total1 = detailFormulaire.controls[rang].get(idChamp1).value;
    }
    if (detailFormulaire.controls[rang].get(idChamp2).value === null) {
      total2 = 0;
    } else {
      total2 = detailFormulaire.controls[rang].get(idChamp2).value;
    }
    if (detailFormulaire.controls[rang].get(idChamp3).value === null) {
      total3 = 0;
    } else {
      total3 = detailFormulaire.controls[rang].get(idChamp3).value;
    }
    if (detailFormulaire.controls[rang].get(idChamp4).value === null) {
      total4 = 0;
    } else {
      total4 = detailFormulaire.controls[rang].get(idChamp4).value;
    }
    if (detailFormulaire.controls[rang].get(idChamp5).value === null) {
      total5 = 0;
    } else {
      total5 = detailFormulaire.controls[rang].get(idChamp5).value;
    }
    if (detailFormulaire.controls[rang].get(idChamp6).value === null) {
      total6 = 0;
    } else {
      total6 = detailFormulaire.controls[rang].get(idChamp6).value;
    }

    total = total1 + total2 + total3 + total4 + total5 + total6;

    if (total !== 0) {
      detailFormulaire.controls[rang].get(idTot).setValue(total);
    } else {
        // le total ramene 0 : soit les champs sont non renseignes soit à 0
        // on test qu'une valeur n'est pas renseignée pour remettre total à null sinon on laisse 0
        if ((detailFormulaire.controls[rang].get(idChamp1).value === null)
        && (detailFormulaire.controls[rang].get(idChamp2).value === null)
        && (detailFormulaire.controls[rang].get(idChamp3).value === null)
        && (detailFormulaire.controls[rang].get(idChamp4).value === null)
        && (detailFormulaire.controls[rang].get(idChamp5).value === null)
        && (detailFormulaire.controls[rang].get(idChamp6).value === null)
        ) {
          detailFormulaire.controls[rang].get(idTot).setValue(null);
        } else {
          detailFormulaire.controls[rang].get(idTot).setValue(total);
        }
    }          
}

public calculTotalBoucle8(detailFormulaire: UntypedFormArray, rang: number, idTot: string, idChamp1: string, idChamp2: string, idChamp3: string, idChamp4: string, idChamp5: string, idChamp6: string,
  idChamp7: string, idChamp8: string, indic_decimal: boolean): void {
        
        // on met any car cela peut être un number ou un decimal!
        let total1: any; 
        let total2: any; 
        let total3: any; 
        let total4: any; 
        let total5: any; 
        let total6: any; 
        let total7: any; 
        let total8: any; 
        let total: any; 

          if (detailFormulaire.controls[rang].get(idChamp1).value === null) {
            total1 = 0;
          } else {
            total1 = detailFormulaire.controls[rang].get(idChamp1).value;
          }
          if (detailFormulaire.controls[rang].get(idChamp2).value === null) {
            total2 = 0;
          } else {
            total2 = detailFormulaire.controls[rang].get(idChamp2).value;
          }
          if (detailFormulaire.controls[rang].get(idChamp3).value === null) {
            total3 = 0;
          } else {
            total3 = detailFormulaire.controls[rang].get(idChamp3).value;
          }
          if (detailFormulaire.controls[rang].get(idChamp4).value === null) {
            total4 = 0;
          } else {
            total4 = detailFormulaire.controls[rang].get(idChamp4).value;
          }
          if (detailFormulaire.controls[rang].get(idChamp5).value === null) {
            total5 = 0;
          } else {
            total5 = detailFormulaire.controls[rang].get(idChamp5).value;
          }
          if (detailFormulaire.controls[rang].get(idChamp6).value === null) {
            total6 = 0;
          } else {
            total6 = detailFormulaire.controls[rang].get(idChamp6).value;
          }
          if (detailFormulaire.controls[rang].get(idChamp7).value === null) {
            total7 = 0;
          } else {
            total7 = detailFormulaire.controls[rang].get(idChamp7).value;
          }
          if (detailFormulaire.controls[rang].get(idChamp8).value === null) {
            total8 = 0;
          } else {
            total8 = detailFormulaire.controls[rang].get(idChamp8).value;
          }

          total = total1 + total2 + total3 + total4 + total5 + total6 + total7 + total8;

          if (total !== 0) {
            // on teste si le total est sur des nombres decimaux et il faut forcer dans ces cas là au format à 2 décimales!
            if (indic_decimal === true) {
              total = parseFloat(parseFloat(total).toFixed(2));
            }

            detailFormulaire.controls[rang].get(idTot).setValue(total);
          } else {
              // le total ramene 0 : soit les champs sont non renseignes soit à 0
              // on test qu'une valeur n'est pas renseignée pour remettre total à null sinon on laisse 0
              if ((detailFormulaire.controls[rang].get(idChamp1).value === null)
              && (detailFormulaire.controls[rang].get(idChamp2).value === null)
              && (detailFormulaire.controls[rang].get(idChamp3).value === null)
              && (detailFormulaire.controls[rang].get(idChamp4).value === null)
              && (detailFormulaire.controls[rang].get(idChamp5).value === null)
              && (detailFormulaire.controls[rang].get(idChamp6).value === null)
              && (detailFormulaire.controls[rang].get(idChamp7).value === null)
              && (detailFormulaire.controls[rang].get(idChamp8).value === null)
              ) {
                detailFormulaire.controls[rang].get(idTot).setValue(null);
              } else {
                detailFormulaire.controls[rang].get(idTot).setValue(total);
              }
          }          
}

public calculTotalBoucle10(detailFormulaire: UntypedFormArray, rang: number, idTot: string, idChamp1: string, idChamp2: string, idChamp3: string, idChamp4: string, idChamp5: string, idChamp6: string,
  idChamp7: string, idChamp8: string, idChamp9: string, idChamp10: string): void {

        let total1: number; 
        let total2: number; 
        let total3: number; 
        let total4: number; 
        let total5: number; 
        let total6: number; 
        let total7: number; 
        let total8: number; 
        let total9: number; 
        let total10: number; 
        let total: number; 

          if (detailFormulaire.controls[rang].get(idChamp1).value === null) {
            total1 = 0;
          } else {
            total1 = detailFormulaire.controls[rang].get(idChamp1).value;
          }
          if (detailFormulaire.controls[rang].get(idChamp2).value === null) {
            total2 = 0;
          } else {
            total2 = detailFormulaire.controls[rang].get(idChamp2).value;
          }
          if (detailFormulaire.controls[rang].get(idChamp3).value === null) {
            total3 = 0;
          } else {
            total3 = detailFormulaire.controls[rang].get(idChamp3).value;
          }
          if (detailFormulaire.controls[rang].get(idChamp4).value === null) {
            total4 = 0;
          } else {
            total4 = detailFormulaire.controls[rang].get(idChamp4).value;
          }
          if (detailFormulaire.controls[rang].get(idChamp5).value === null) {
            total5 = 0;
          } else {
            total5 = detailFormulaire.controls[rang].get(idChamp5).value;
          }
          if (detailFormulaire.controls[rang].get(idChamp6).value === null) {
            total6 = 0;
          } else {
            total6 = detailFormulaire.controls[rang].get(idChamp6).value;
          }
          if (detailFormulaire.controls[rang].get(idChamp7).value === null) {
            total7 = 0;
          } else {
            total7 = detailFormulaire.controls[rang].get(idChamp7).value;
          }
          if (detailFormulaire.controls[rang].get(idChamp8).value === null) {
            total8 = 0;
          } else {
            total8 = detailFormulaire.controls[rang].get(idChamp8).value;
          }
          if (detailFormulaire.controls[rang].get(idChamp9).value === null) {
            total9 = 0;
          } else {
            total9 = detailFormulaire.controls[rang].get(idChamp9).value;
          }
          if (detailFormulaire.controls[rang].get(idChamp10).value === null) {
            total10 = 0;
          } else {
            total10 = detailFormulaire.controls[rang].get(idChamp10).value;
          }

          total = total1 + total2 + total3 + total4 + total5 + total6 + total7 + total8 + total9 + total10;

          if (total !== 0) {
            detailFormulaire.controls[rang].get(idTot).setValue(total);
          } else {
              // le total ramene 0 : soit les champs sont non renseignes soit à 0
              // on test qu'une valeur n'est pas renseignée pour remettre total à null sinon on laisse 0
              if ((detailFormulaire.controls[rang].get(idChamp1).value === null)
              && (detailFormulaire.controls[rang].get(idChamp2).value === null)
              && (detailFormulaire.controls[rang].get(idChamp3).value === null)
              && (detailFormulaire.controls[rang].get(idChamp4).value === null)
              && (detailFormulaire.controls[rang].get(idChamp5).value === null)
              && (detailFormulaire.controls[rang].get(idChamp6).value === null)
              && (detailFormulaire.controls[rang].get(idChamp7).value === null)
              && (detailFormulaire.controls[rang].get(idChamp8).value === null)
              && (detailFormulaire.controls[rang].get(idChamp9).value === null)
              && (detailFormulaire.controls[rang].get(idChamp10).value === null)
              ) {
                detailFormulaire.controls[rang].get(idTot).setValue(null);
              } else {
                detailFormulaire.controls[rang].get(idTot).setValue(total);
              }
          }          
}

public calculTotalBoucle19(detailFormulaire: UntypedFormArray, rang: number, idTot: string, idChamp1: string, idChamp2: string, idChamp3: string, idChamp4: string, idChamp5: string, idChamp6: string,
  idChamp7: string, idChamp8: string, idChamp9: string, idChamp10: string, idChamp11: string, idChamp12: string, idChamp13: string, idChamp14: string
  , idChamp15: string, idChamp16: string, idChamp17: string, idChamp18: string, idChamp19: string): void {

        let total1: number; 
        let total2: number; 
        let total3: number; 
        let total4: number; 
        let total5: number; 
        let total6: number; 
        let total7: number; 
        let total8: number; 
        let total9: number; 
        let total10: number; 
        let total11: number; 
        let total12: number; 
        let total13: number; 
        let total14: number; 
        let total15: number; 
        let total16: number; 
        let total17: number; 
        let total18: number; 
        let total19: number; 
        let total: number; 

          if (detailFormulaire.controls[rang].get(idChamp1).value === null) {
            total1 = 0;
          } else {
            total1 = detailFormulaire.controls[rang].get(idChamp1).value;
          }
          if (detailFormulaire.controls[rang].get(idChamp2).value === null) {
            total2 = 0;
          } else {
            total2 = detailFormulaire.controls[rang].get(idChamp2).value;
          }
          if (detailFormulaire.controls[rang].get(idChamp3).value === null) {
            total3 = 0;
          } else {
            total3 = detailFormulaire.controls[rang].get(idChamp3).value;
          }
          if (detailFormulaire.controls[rang].get(idChamp4).value === null) {
            total4 = 0;
          } else {
            total4 = detailFormulaire.controls[rang].get(idChamp4).value;
          }
          if (detailFormulaire.controls[rang].get(idChamp5).value === null) {
            total5 = 0;
          } else {
            total5 = detailFormulaire.controls[rang].get(idChamp5).value;
          }
          if (detailFormulaire.controls[rang].get(idChamp6).value === null) {
            total6 = 0;
          } else {
            total6 = detailFormulaire.controls[rang].get(idChamp6).value;
          }
          if (detailFormulaire.controls[rang].get(idChamp7).value === null) {
            total7 = 0;
          } else {
            total7 = detailFormulaire.controls[rang].get(idChamp7).value;
          }
          if (detailFormulaire.controls[rang].get(idChamp8).value === null) {
            total8 = 0;
          } else {
            total8 = detailFormulaire.controls[rang].get(idChamp8).value;
          }
          if (detailFormulaire.controls[rang].get(idChamp9).value === null) {
            total9 = 0;
          } else {
            total9 = detailFormulaire.controls[rang].get(idChamp9).value;
          }
          if (detailFormulaire.controls[rang].get(idChamp10).value === null) {
            total10 = 0;
          } else {
            total10 = detailFormulaire.controls[rang].get(idChamp10).value;
          }
          if (detailFormulaire.controls[rang].get(idChamp11).value === null) {
            total11 = 0;
          } else {
            total11 = detailFormulaire.controls[rang].get(idChamp11).value;
          }
          if (detailFormulaire.controls[rang].get(idChamp12).value === null) {
            total12 = 0;
          } else {
            total12 = detailFormulaire.controls[rang].get(idChamp12).value;
          }
          if (detailFormulaire.controls[rang].get(idChamp13).value === null) {
            total13 = 0;
          } else {
            total13 = detailFormulaire.controls[rang].get(idChamp13).value;
          }
          if (detailFormulaire.controls[rang].get(idChamp14).value === null) {
            total14 = 0;
          } else {
            total14 = detailFormulaire.controls[rang].get(idChamp14).value;
          }
          if (detailFormulaire.controls[rang].get(idChamp15).value === null) {
            total15 = 0;
          } else {
            total15 = detailFormulaire.controls[rang].get(idChamp15).value;
          }
          if (detailFormulaire.controls[rang].get(idChamp16).value === null) {
            total16 = 0;
          } else {
            total16 = detailFormulaire.controls[rang].get(idChamp16).value;
          }
          if (detailFormulaire.controls[rang].get(idChamp17).value === null) {
            total17 = 0;
          } else {
            total17 = detailFormulaire.controls[rang].get(idChamp17).value;
          }
          if (detailFormulaire.controls[rang].get(idChamp18).value === null) {
            total18 = 0;
          } else {
            total18 = detailFormulaire.controls[rang].get(idChamp18).value;
          }
          if (detailFormulaire.controls[rang].get(idChamp19).value === null) {
            total19 = 0;
          } else {
            total19 = detailFormulaire.controls[rang].get(idChamp19).value;
          }

          total = total1 + total2 + total3 + total4 + total5 + total6 + total7 + total8 + total9 + total10 + total11 + total12 + total13 + total14 + total15 + total16 + total17 + total18 + total19;

          if (total !== 0) {
            detailFormulaire.controls[rang].get(idTot).setValue(total);
          } else {
              // le total ramene 0 : soit les champs sont non renseignes soit à 0
              // on test qu'une valeur n'est pas renseignée pour remettre total à null sinon on laisse 0
              if ((detailFormulaire.controls[rang].get(idChamp1).value === null)
              && (detailFormulaire.controls[rang].get(idChamp2).value === null)
              && (detailFormulaire.controls[rang].get(idChamp3).value === null)
              && (detailFormulaire.controls[rang].get(idChamp4).value === null)
              && (detailFormulaire.controls[rang].get(idChamp5).value === null)
              && (detailFormulaire.controls[rang].get(idChamp6).value === null)
              && (detailFormulaire.controls[rang].get(idChamp7).value === null)
              && (detailFormulaire.controls[rang].get(idChamp8).value === null)
              && (detailFormulaire.controls[rang].get(idChamp9).value === null)
              && (detailFormulaire.controls[rang].get(idChamp10).value === null)
              && (detailFormulaire.controls[rang].get(idChamp11).value === null)
              && (detailFormulaire.controls[rang].get(idChamp12).value === null)
              && (detailFormulaire.controls[rang].get(idChamp13).value === null)
              && (detailFormulaire.controls[rang].get(idChamp14).value === null)
              && (detailFormulaire.controls[rang].get(idChamp15).value === null)
              && (detailFormulaire.controls[rang].get(idChamp16).value === null)
              && (detailFormulaire.controls[rang].get(idChamp17).value === null)
              && (detailFormulaire.controls[rang].get(idChamp18).value === null)
              && (detailFormulaire.controls[rang].get(idChamp19).value === null)
              ) {
                detailFormulaire.controls[rang].get(idTot).setValue(null);
              } else {
                detailFormulaire.controls[rang].get(idTot).setValue(total);
              }
          }          
}

//Fonction pour les controles bloquants sur la boucle des lieux de permanence Tribunal (TJ/TPI/TPRX)
public ajoutValidateurCroiseLieuxTj (formulaire: UntypedFormArray, index: number) {
  const currentForm: UntypedFormGroup = formulaire.controls[index] as UntypedFormGroup;
  currentForm.setValidators([
    this.validationService.ctrlA62Tj,
    this.validationService.ctrlA63Tj
  ]);
}

//Fonction pour les controles bloquants sur la boucle des personnes recues (TJ)
public ajoutValidateurCroisePersonnesRecues (formulaire: UntypedFormArray, index: number) {
  const currentForm: UntypedFormGroup = formulaire.controls[index] as UntypedFormGroup;
  currentForm.setValidators([
  this.validationService.ctrlC21Tj,
  this.validationService.ctrlC22Tj
  ]);
}

//Fonction pour les controles bloquants sur la boucle des lieux de permanence BAV
public ajoutValidateurCroiseLieuxBav (formulaire: UntypedFormArray, index: number) {
  const currentForm: UntypedFormGroup = formulaire.controls[index] as UntypedFormGroup;
  currentForm.setValidators([
    this.validationService.ctrlA64Bav,
    this.validationService.ctrlA65Bav
  ]);
}

//Fonction pour les controles bloquants sur la boucle des BAV
public ajoutValidateurCroiseBAV (formulaire: UntypedFormArray, index: number) {
  const currentForm: UntypedFormGroup = formulaire.controls[index] as UntypedFormGroup;
  currentForm.setValidators([
   this.validationService.ctrlF1Bav,
   this.validationService.ctrlF2Bav,
   this.validationService.ctrlF3Bav,
   this.validationService.ctrlF4Bav,
   this.validationService.ctrlF23Bav,
   this.validationService.ctrlF5Bav,
   this.validationService.ctrlF24Bav,
   this.validationService.ctrlF25Bav,
   this.validationService.ctrlF6Bav,
   this.validationService.ctrlF26Bav,
   this.validationService.ctrlF27Bav,
   this.validationService.ctrlF7Bav,
   this.validationService.ctrlF28Bav,
   this.validationService.ctrlF29Bav,
   this.validationService.ctrlF30Bav,
   this.validationService.ctrlF8Bav,
   this.validationService.ctrlF9Bav,
   this.validationService.ctrlF10Bav,
   this.validationService.ctrlF11Bav,
   this.validationService.ctrlF31Bav,
   this.validationService.ctrlF12Bav,
   this.validationService.ctrlF13Bav,
   this.validationService.ctrlF32Bav,
   this.validationService.ctrlF33Bav,
   this.validationService.ctrlF14Bav,
   this.validationService.ctrlF15Bav,
   this.validationService.ctrlF16Bav,
   this.validationService.ctrlF17Bav,
   this.validationService.ctrlF18Bav,
   this.validationService.ctrlF19Bav,
   this.validationService.ctrlF20Bav
  ]);
}

// Initialisation des totaux de la synthèse
public initCalculSynthese(): void {
      this.bavtotAaNbAav = 0;
      this.bavtotAaNbJur = 0;
      this.bavtotAaNbPsy = 0;
      this.bavtotAaNbWsoc = 0;
      this.bavtotAaNbAutrInterv = 0;
      this.bavtotAaNbDir = 0;
      this.bavtotAaNbComptsecr = 0;
      this.bavtotAaNbAutrSupport = 0;
      this.bavtotAaNbTot = 0;

      this.bavtotAaEtpAav_number = 0;
      this.bavtotAaEtpJur_number = 0;
      this.bavtotAaEtpPsy_number = 0;
      this.bavtotAaEtpWsoc_number = 0;
      this.bavtotAaEtpAutrInterv_number = 0;
      this.bavtotAaEtpDir_number = 0;
      this.bavtotAaEtpComptsecr_number = 0;
      this.bavtotAaEtpAutrSupport_number = 0;
      this.bavtotAaEtpTot_number = 0;

      this.bavtotBbPremContactOrigAsso = 0;
      this.bavtotBbPremContactOrigPerso = 0;
      this.bavtotBbPremContactOrigTot = 0;
      this.bavtotBbPremContactModeEcrit = 0;
      this.bavtotBbPremContactModeTel = 0;
      this.bavtotBbPremContactModePres = 0;
      this.bavtotBbPremContactModeTot = 0;
      this.bavtotCcRecuVictNb = 0;
      this.bavtotCcRecuVictSuivi = 0;
      this.bavtotCcRecuVictEntret = 0;
      this.bavtotCcRecuNvictNb = 0;
      this.bavtotCcRecuNvictSuivi = 0;
      this.bavtotCcRecuNvictEntret = 0;
      this.bavtotCcRecuNbTot = 0;
      this.bavtotCcRecuSuiviTot = 0;
      this.bavtotCcRecuEntretTot = 0;
      this.bavtotCcRecuVict = 0;
      this.bavtotCcRecuVictPc = 0;
      this.bavtotCcRecuVictAud = 0;
      this.bavtotDdFaitPersoHomiVolo = 0;
      this.bavtotDdFaitPersoSexuel = 0;
      this.bavtotDdFaitPersoProxe = 0;
      this.bavtotDdFaitPersoViolen = 0;
      this.bavtotDdFaitPersoHomiInvolo = 0;
      this.bavtotDdFaitPersoBless = 0;
      this.bavtotDdFaitPersoAband = 0;
      this.bavtotDdFaitPersoMenace = 0;
      this.bavtotDdFaitPersoDiscri = 0;
      this.bavtotDdFaitPersoAutr = 0;
      this.bavtotDdFaitPersoTot = 0;
      this.bavtotDdFaitBienVolSimp = 0;
      this.bavtotDdFaitBienVolAggr = 0;
      this.bavtotDdFaitBienEscro = 0;
      this.bavtotDdFaitBienDegrad = 0;
      this.bavtotDdFaitBienAutr = 0;
      this.bavtotDdFaitBienTot = 0;
      this.bavtotDdFaitCircuBless = 0;
      this.bavtotDdFaitCircuDegat = 0;
      this.bavtotDdFaitCircuTot = 0;
      this.bavtotDdFaitAutr = 0;
      this.bavtotDdFaitTot = 0;
      this.bavtotEeEntretPsy = 0;
      this.bavtotEeEntretJur = 0;
      this.bavtotEeEntretSoc = 0;
      this.bavtotEeEntretEcout = 0;
      this.bavtotEeEntretAutr = 0;
      this.bavtotEeEntretTot = 0;
      this.bavtotEeDiliJur = 0;
      this.bavtotEeDiliCivi = 0;
      this.bavtotEeDiliFondGaran = 0;
      this.bavtotEeDiliSarvi = 0;
      this.bavtotEeDiliPenit = 0;
      this.bavtotEeDiliPolgend = 0;
      this.bavtotEeDiliAvoc = 0;
      this.bavtotEeDiliHuis = 0;
      this.bavtotEeDiliOrgaSoc = 0;
      this.bavtotEeDiliColter = 0;
      this.bavtotEeDiliPref = 0;
      this.bavtotEeDiliOrgaLogt = 0;
      this.bavtotEeDiliHebgt = 0;
      this.bavtotEeDiliHosto = 0;
      this.bavtotEeDiliAsso = 0;
      this.bavtotEeDiliAssur = 0;
      this.bavtotEeDiliSad = 0;
      this.bavtotEeDiliFrserv = 0;
      this.bavtotEeDiliAutr = 0;
      this.bavtotEeDiliTot = 0;
      this.bavtotEeAideCivi = 0;
      this.bavtotEeAideSarvi = 0;
      this.bavtotEeProcPreSentenPlainte = 0;
      this.bavtotEeProcPreSentenEnq = 0;
      this.bavtotEeProcPreSentenCss = 0;
      this.bavtotEeProcPreSentenPc = 0;
      this.bavtotEeProcPreSentenAud = 0;
      this.bavtotEeProcPreSentenAutr = 0;
      this.bavtotEeProcPreSentenTot = 0;
      this.bavtotEeProcPostSentenDec = 0;
      this.bavtotEeProcPostSentenDef = 0;
      this.bavtotEeProcPostSentenRecour = 0;
      this.bavtotEeProcPostSentenAutr = 0;
      this.bavtotEeProcPostSentenTot = 0;
      this.bavtotEeAuteurPreSentenCj = 0;
      this.bavtotEeAuteurPreSentenDp = 0;
      this.bavtotEeAuteurPreSentenFinDeten = 0;
      this.bavtotEeAuteurPreSentenFinMes = 0;
      this.bavtotEeAuteurPreSentenAutr = 0;
      this.bavtotEeAuteurPreSentenTot = 0;
      this.bavtotEeAuteurPostSentenMilFer = 0;
      this.bavtotEeAuteurPostSentenMilOuv = 0;
      this.bavtotEeAuteurPostSentenFinDeten = 0;
      this.bavtotEeAuteurPostSentenFinMes = 0;
      this.bavtotEeAuteurPostSentenAutr = 0;
      this.bavtotEeAuteurPostSentenTot = 0;
      this.bavtotEeDiPreSentenCivi = 0;
      this.bavtotEeDiPreSentenAutr = 0;
      this.bavtotEeDiPreSentenTot = 0;
      this.bavtotEeDiPostSentenCivi = 0;
      this.bavtotEeDiPostSentenSarvi = 0;
      this.bavtotEeDiPostSentenHuis = 0;
      this.bavtotEeDiPostSentenJapSpip = 0;
      this.bavtotEeDiPostSentenFondGar = 0;
      this.bavtotEeDiPostSentenAutr = 0;
      this.bavtotEeDiPostSentenTot = 0;
      this.bavtotEeFoncJudic = 0;
      this.bavtotEeDemarPlainte = 0;
      this.bavtotEeDemarAj = 0;
      this.bavtotEeDemarAud = 0;
      this.bavtotEeDemarAccomp = 0;
      this.bavtotEeDemarDi = 0;
      this.bavtotEeDemarAutr = 0;
      this.bavtotEeDemarTot = 0;
}

public majsSynthese(nomFormulaire: any, detailBoucle: any): void {
  // Initialisation variables de calculs
  this.initCalculSynthese();

  // On somme chaque variable BAV des boucles pour afficher en synthèse le total par variable
  detailBoucle.value.forEach(bav => {
    this.bavtotAaNbAav = this.bavtotAaNbAav + (bav.bavAaNbAav || 0);
    this.bavtotAaNbJur = this.bavtotAaNbJur + (bav.bavAaNbJur || 0);
    this.bavtotAaNbPsy = this.bavtotAaNbPsy + (bav.bavAaNbPsy || 0);
    this.bavtotAaNbWsoc = this.bavtotAaNbWsoc + (bav.bavAaNbWsoc || 0);
    this.bavtotAaNbAutrInterv = this.bavtotAaNbAutrInterv + (bav.bavAaNbAutrInterv || 0);
    this.bavtotAaNbDir = this.bavtotAaNbDir + (bav.bavAaNbDir || 0);
    this.bavtotAaNbComptsecr = this.bavtotAaNbComptsecr + (bav.bavAaNbComptsecr || 0);
    this.bavtotAaNbAutrSupport = this.bavtotAaNbAutrSupport + (bav.bavAaNbAutrSupport || 0);
    this.bavtotAaEtpAav_number = this.bavtotAaEtpAav_number + (bav.bavAaEtpAav || 0);
    this.bavtotAaEtpJur_number = this.bavtotAaEtpJur_number + (bav.bavAaEtpJur || 0);
    this.bavtotAaEtpPsy_number = this.bavtotAaEtpPsy_number + (bav.bavAaEtpPsy || 0);
    this.bavtotAaEtpWsoc_number = this.bavtotAaEtpWsoc_number + (bav.bavAaEtpWsoc || 0);
    this.bavtotAaEtpAutrInterv_number = this.bavtotAaEtpAutrInterv_number + (bav.bavAaEtpAutrInterv || 0);
    this.bavtotAaEtpDir_number = this.bavtotAaEtpDir_number + (bav.bavAaEtpDir || 0);
    this.bavtotAaEtpComptsecr_number = this.bavtotAaEtpComptsecr_number + (bav.bavAaEtpComptsecr || 0);
    this.bavtotAaEtpAutrSupport_number = this.bavtotAaEtpAutrSupport_number + (bav.bavAaEtpAutrSupport || 0);
    this.bavtotBbPremContactOrigAsso = this.bavtotBbPremContactOrigAsso + (bav.bavBbPremContactOrigAsso || 0);
    this.bavtotBbPremContactOrigPerso = this.bavtotBbPremContactOrigPerso + (bav.bavBbPremContactOrigPerso || 0);
    this.bavtotBbPremContactModeEcrit = this.bavtotBbPremContactModeEcrit + (bav.bavBbPremContactModeEcrit || 0);
    this.bavtotBbPremContactModeTel = this.bavtotBbPremContactModeTel + (bav.bavBbPremContactModeTel || 0);
    this.bavtotBbPremContactModePres = this.bavtotBbPremContactModePres + (bav.bavBbPremContactModePres || 0);
    this.bavtotCcRecuVictNb = this.bavtotCcRecuVictNb + (bav.bavCcRecuVictNb || 0);
    this.bavtotCcRecuVictSuivi = this.bavtotCcRecuVictSuivi + (bav.bavCcRecuVictSuivi || 0);
    this.bavtotCcRecuVictEntret = this.bavtotCcRecuVictEntret + (bav.bavCcRecuVictEntret || 0);
    this.bavtotCcRecuNvictNb = this.bavtotCcRecuNvictNb + (bav.bavCcRecuNvictNb || 0);
    this.bavtotCcRecuNvictSuivi = this.bavtotCcRecuNvictSuivi + (bav.bavCcRecuNvictSuivi || 0);
    this.bavtotCcRecuNvictEntret = this.bavtotCcRecuNvictEntret + (bav.bavCcRecuNvictEntret || 0);
    this.bavtotCcRecuVict = this.bavtotCcRecuVict + (bav.bavCcRecuVict || 0);
    this.bavtotCcRecuVictPc = this.bavtotCcRecuVictPc + (bav.bavCcRecuVictPc || 0);
    this.bavtotCcRecuVictAud = this.bavtotCcRecuVictAud + (bav.bavCcRecuVictAud || 0);
    this.bavtotDdFaitPersoHomiVolo = this.bavtotDdFaitPersoHomiVolo + (bav.bavDdFaitPersoHomiVolo || 0);
    this.bavtotDdFaitPersoSexuel = this.bavtotDdFaitPersoSexuel + (bav.bavDdFaitPersoSexuel || 0);
    this.bavtotDdFaitPersoProxe = this.bavtotDdFaitPersoProxe + (bav.bavDdFaitPersoProxe || 0);
    this.bavtotDdFaitPersoViolen = this.bavtotDdFaitPersoViolen + (bav.bavDdFaitPersoViolen || 0);
    this.bavtotDdFaitPersoHomiInvolo = this.bavtotDdFaitPersoHomiInvolo + (bav.bavDdFaitPersoHomiInvolo || 0);
    this.bavtotDdFaitPersoBless = this.bavtotDdFaitPersoBless + (bav.bavDdFaitPersoBless || 0);
    this.bavtotDdFaitPersoAband = this.bavtotDdFaitPersoAband + (bav.bavDdFaitPersoAband || 0);
    this.bavtotDdFaitPersoMenace = this.bavtotDdFaitPersoMenace + (bav.bavDdFaitPersoMenace || 0);
    this.bavtotDdFaitPersoDiscri = this.bavtotDdFaitPersoDiscri + (bav.bavDdFaitPersoDiscri || 0);
    this.bavtotDdFaitPersoAutr = this.bavtotDdFaitPersoAutr + (bav.bavDdFaitPersoAutr || 0);
    this.bavtotDdFaitBienVolSimp = this.bavtotDdFaitBienVolSimp + (bav.bavDdFaitBienVolSimp || 0);
    this.bavtotDdFaitBienVolAggr = this.bavtotDdFaitBienVolAggr + (bav.bavDdFaitBienVolAggr || 0);
    this.bavtotDdFaitBienEscro = this.bavtotDdFaitBienEscro + (bav.bavDdFaitBienEscro || 0);
    this.bavtotDdFaitBienDegrad = this.bavtotDdFaitBienDegrad + (bav.bavDdFaitBienDegrad || 0);
    this.bavtotDdFaitBienAutr = this.bavtotDdFaitBienAutr + (bav.bavDdFaitBienAutr || 0);
    this.bavtotDdFaitCircuBless = this.bavtotDdFaitCircuBless + (bav.bavDdFaitCircuBless || 0);
    this.bavtotDdFaitCircuDegat = this.bavtotDdFaitCircuDegat + (bav.bavDdFaitCircuDegat || 0);
    this.bavtotDdFaitAutr = this.bavtotDdFaitAutr + (bav.bavDdFaitAutr || 0);
    this.bavtotEeEntretPsy = this.bavtotEeEntretPsy + (bav.bavEeEntretPsy || 0);
    this.bavtotEeEntretJur = this.bavtotEeEntretJur + (bav.bavEeEntretJur || 0);
    this.bavtotEeEntretSoc = this.bavtotEeEntretSoc + (bav.bavEeEntretSoc || 0);
    this.bavtotEeEntretEcout = this.bavtotEeEntretEcout + (bav.bavEeEntretEcout || 0);
    this.bavtotEeEntretAutr = this.bavtotEeEntretAutr + (bav.bavEeEntretAutr || 0);
    this.bavtotEeDiliJur = this.bavtotEeDiliJur + (bav.bavEeDiliJur || 0);
    this.bavtotEeDiliCivi = this.bavtotEeDiliCivi + (bav.bavEeDiliCivi || 0);
    this.bavtotEeDiliFondGaran = this.bavtotEeDiliFondGaran + (bav.bavEeDiliFondGaran || 0);
    this.bavtotEeDiliSarvi = this.bavtotEeDiliSarvi + (bav.bavEeDiliSarvi || 0);
    this.bavtotEeDiliPenit = this.bavtotEeDiliPenit + (bav.bavEeDiliPenit || 0);
    this.bavtotEeDiliPolgend = this.bavtotEeDiliPolgend + (bav.bavEeDiliPolgend || 0);
    this.bavtotEeDiliAvoc = this.bavtotEeDiliAvoc + (bav.bavEeDiliAvoc || 0);
    this.bavtotEeDiliHuis = this.bavtotEeDiliHuis + (bav.bavEeDiliHuis || 0);
    this.bavtotEeDiliOrgaSoc = this.bavtotEeDiliOrgaSoc + (bav.bavEeDiliOrgaSoc || 0);
    this.bavtotEeDiliColter = this.bavtotEeDiliColter + (bav.bavEeDiliColter || 0);
    this.bavtotEeDiliPref = this.bavtotEeDiliPref + (bav.bavEeDiliPref || 0);
    this.bavtotEeDiliOrgaLogt = this.bavtotEeDiliOrgaLogt + (bav.bavEeDiliOrgaLogt || 0);
    this.bavtotEeDiliHebgt = this.bavtotEeDiliHebgt + (bav.bavEeDiliHebgt || 0);
    this.bavtotEeDiliHosto = this.bavtotEeDiliHosto + (bav.bavEeDiliHosto || 0);
    this.bavtotEeDiliAsso = this.bavtotEeDiliAsso + (bav.bavEeDiliAsso || 0);
    this.bavtotEeDiliAssur = this.bavtotEeDiliAssur + (bav.bavEeDiliAssur || 0);
    this.bavtotEeDiliSad = this.bavtotEeDiliSad + (bav.bavEeDiliSad || 0);
    this.bavtotEeDiliFrserv = this.bavtotEeDiliFrserv + (bav.bavEeDiliFrserv || 0);
    this.bavtotEeDiliAutr = this.bavtotEeDiliAutr + (bav.bavEeDiliAutr || 0);
    this.bavtotEeAideCivi = this.bavtotEeAideCivi + (bav.bavEeAideCivi || 0);
    this.bavtotEeAideSarvi = this.bavtotEeAideSarvi + (bav.bavEeAideSarvi || 0);
    this.bavtotEeProcPreSentenPlainte = this.bavtotEeProcPreSentenPlainte + (bav.bavEeProcPreSentenPlainte || 0);
    this.bavtotEeProcPreSentenEnq = this.bavtotEeProcPreSentenEnq + (bav.bavEeProcPreSentenEnq || 0);
    this.bavtotEeProcPreSentenCss = this.bavtotEeProcPreSentenCss + (bav.bavEeProcPreSentenCss || 0);
    this.bavtotEeProcPreSentenPc = this.bavtotEeProcPreSentenPc + (bav.bavEeProcPreSentenPc || 0);
    this.bavtotEeProcPreSentenAud = this.bavtotEeProcPreSentenAud + (bav.bavEeProcPreSentenAud || 0);
    this.bavtotEeProcPreSentenAutr = this.bavtotEeProcPreSentenAutr + (bav.bavEeProcPreSentenAutr || 0);
    this.bavtotEeProcPostSentenDec = this.bavtotEeProcPostSentenDec + (bav.bavEeProcPostSentenDec || 0);
    this.bavtotEeProcPostSentenDef = this.bavtotEeProcPostSentenDef + (bav.bavEeProcPostSentenDef || 0);
    this.bavtotEeProcPostSentenRecour = this.bavtotEeProcPostSentenRecour + (bav.bavEeProcPostSentenRecour || 0);
    this.bavtotEeProcPostSentenAutr = this.bavtotEeProcPostSentenAutr + (bav.bavEeProcPostSentenAutr || 0);
    this.bavtotEeAuteurPreSentenCj = this.bavtotEeAuteurPreSentenCj + (bav.bavEeAuteurPreSentenCj || 0);
    this.bavtotEeAuteurPreSentenDp = this.bavtotEeAuteurPreSentenDp + (bav.bavEeAuteurPreSentenDp || 0);
    this.bavtotEeAuteurPreSentenFinDeten = this.bavtotEeAuteurPreSentenFinDeten + (bav.bavEeAuteurPreSentenFinDeten || 0);
    this.bavtotEeAuteurPreSentenFinMes = this.bavtotEeAuteurPreSentenFinMes + (bav.bavEeAuteurPreSentenFinMes || 0);
    this.bavtotEeAuteurPreSentenAutr = this.bavtotEeAuteurPreSentenAutr + (bav.bavEeAuteurPreSentenAutr || 0);
    this.bavtotEeAuteurPostSentenMilFer = this.bavtotEeAuteurPostSentenMilFer + (bav.bavEeAuteurPostSentenMilFer || 0);
    this.bavtotEeAuteurPostSentenMilOuv = this.bavtotEeAuteurPostSentenMilOuv + (bav.bavEeAuteurPostSentenMilOuv || 0);
    this.bavtotEeAuteurPostSentenFinDeten = this.bavtotEeAuteurPostSentenFinDeten + (bav.bavEeAuteurPostSentenFinDeten || 0);
    this.bavtotEeAuteurPostSentenFinMes = this.bavtotEeAuteurPostSentenFinMes + (bav.bavEeAuteurPostSentenFinMes || 0);
    this.bavtotEeAuteurPostSentenAutr = this.bavtotEeAuteurPostSentenAutr + (bav.bavEeAuteurPostSentenAutr || 0);
    this.bavtotEeDiPreSentenCivi = this.bavtotEeDiPreSentenCivi + (bav.bavEeDiPreSentenCivi || 0);
    this.bavtotEeDiPreSentenAutr = this.bavtotEeDiPreSentenAutr + (bav.bavEeDiPreSentenAutr || 0);
    this.bavtotEeDiPostSentenCivi = this.bavtotEeDiPostSentenCivi + (bav.bavEeDiPostSentenCivi || 0);
    this.bavtotEeDiPostSentenSarvi = this.bavtotEeDiPostSentenSarvi + (bav.bavEeDiPostSentenSarvi || 0);
    this.bavtotEeDiPostSentenHuis = this.bavtotEeDiPostSentenHuis + (bav.bavEeDiPostSentenHuis || 0);
    this.bavtotEeDiPostSentenJapSpip = this.bavtotEeDiPostSentenJapSpip + (bav.bavEeDiPostSentenJapSpip || 0);
    this.bavtotEeDiPostSentenFondGar = this.bavtotEeDiPostSentenFondGar + (bav.bavEeDiPostSentenFondGar || 0);
    this.bavtotEeDiPostSentenAutr = this.bavtotEeDiPostSentenAutr + (bav.bavEeDiPostSentenAutr || 0);
    this.bavtotEeFoncJudic = this.bavtotEeFoncJudic + (bav.bavEeFoncJudic || 0);
    this.bavtotEeDemarPlainte = this.bavtotEeDemarPlainte + (bav.bavEeDemarPlainte || 0);
    this.bavtotEeDemarAj = this.bavtotEeDemarAj + (bav.bavEeDemarAj || 0);
    this.bavtotEeDemarAud = this.bavtotEeDemarAud + (bav.bavEeDemarAud || 0);
    this.bavtotEeDemarAccomp = this.bavtotEeDemarAccomp + (bav.bavEeDemarAccomp || 0);
    this.bavtotEeDemarDi = this.bavtotEeDemarDi + (bav.bavEeDemarDi || 0);
    this.bavtotEeDemarAutr = this.bavtotEeDemarAutr + (bav.bavEeDemarAutr || 0);
    this.bavtotAaNbTot = this.bavtotAaNbTot + (bav.bavAaNbTot || 0);
    this.bavtotAaEtpTot_number = this.bavtotAaEtpTot_number + (bav.bavAaEtpTot || 0);
    this.bavtotBbPremContactOrigTot = this.bavtotBbPremContactOrigTot + (bav.bavBbPremContactOrigTot || 0);
    this.bavtotBbPremContactModeTot = this.bavtotBbPremContactModeTot + (bav.bavBbPremContactModeTot ||0) ;
    this.bavtotCcRecuNbTot = this.bavtotCcRecuNbTot + (bav.bavCcRecuNbTot || 0);
    this.bavtotCcRecuSuiviTot = this.bavtotCcRecuSuiviTot + (bav.bavCcRecuSuiviTot || 0);
    this.bavtotCcRecuEntretTot = this.bavtotCcRecuEntretTot + (bav.bavCcRecuEntretTot || 0);
    this.bavtotDdFaitPersoTot = this.bavtotDdFaitPersoTot + (bav.bavDdFaitPersoTot || 0);
    this.bavtotDdFaitBienTot = this.bavtotDdFaitBienTot + (bav.bavDdFaitBienTot || 0);
    this.bavtotDdFaitCircuTot = this.bavtotDdFaitCircuTot + (bav.bavDdFaitCircuTot ||0);
    this.bavtotDdFaitTot = this.bavtotDdFaitTot + (bav.bavDdFaitTot || 0);
    this.bavtotEeEntretTot = this.bavtotEeEntretTot + (bav.bavEeEntretTot || 0);
    this.bavtotEeDiliTot = this.bavtotEeDiliTot + (bav.bavEeDiliTot || 0);
    this.bavtotEeProcPreSentenTot = this.bavtotEeProcPreSentenTot + (bav.bavEeProcPreSentenTot || 0);
    this.bavtotEeProcPostSentenTot = this.bavtotEeProcPostSentenTot + (bav.bavEeProcPostSentenTot || 0);
    this.bavtotEeAuteurPreSentenTot = this.bavtotEeAuteurPreSentenTot + (bav.bavEeAuteurPreSentenTot || 0);
    this.bavtotEeAuteurPostSentenTot = this.bavtotEeAuteurPostSentenTot + (bav.bavEeAuteurPostSentenTot || 0);
    this.bavtotEeDiPreSentenTot = this.bavtotEeDiPreSentenTot + (bav.bavEeDiPreSentenTot || 0);
    this.bavtotEeDiPostSentenTot = this.bavtotEeDiPostSentenTot + (bav.bavEeDiPostSentenTot || 0);
    this.bavtotEeDemarTot = this.bavtotEeDemarTot + (bav.bavEeDemarTot || 0);
  });

  // Formatage des zones décimales à 2 décimales!
  this.bavtotAaEtpAav = parseFloat(this.bavtotAaEtpAav_number.toString()).toFixed(2);
  this.bavtotAaEtpJur = parseFloat(this.bavtotAaEtpJur_number.toString()).toFixed(2);
  this.bavtotAaEtpPsy = parseFloat(this.bavtotAaEtpPsy_number.toString()).toFixed(2);
  this.bavtotAaEtpWsoc = parseFloat(this.bavtotAaEtpWsoc_number.toString()).toFixed(2);
  this.bavtotAaEtpAutrInterv = parseFloat(this.bavtotAaEtpAutrInterv_number.toString()).toFixed(2);
  this.bavtotAaEtpDir = parseFloat(this.bavtotAaEtpDir_number.toString()).toFixed(2);
  this.bavtotAaEtpComptsecr = parseFloat(this.bavtotAaEtpComptsecr_number.toString()).toFixed(2);
  this.bavtotAaEtpAutrSupport = parseFloat(this.bavtotAaEtpAutrSupport_number.toString()).toFixed(2);
  this.bavtotAaEtpTot = parseFloat(this.bavtotAaEtpTot_number.toString()).toFixed(2);

  // On envoie les resultats à la BDD pour enregistrement
  nomFormulaire.get('bavtotAaNbAav').setValue(this.bavtotAaNbAav);
  nomFormulaire.get('bavtotAaNbJur').setValue(this.bavtotAaNbJur);
  nomFormulaire.get('bavtotAaNbPsy').setValue(this.bavtotAaNbPsy);
  nomFormulaire.get('bavtotAaNbWsoc').setValue(this.bavtotAaNbWsoc);
  nomFormulaire.get('bavtotAaNbAutrInterv').setValue(this.bavtotAaNbAutrInterv);
  nomFormulaire.get('bavtotAaNbDir').setValue(this.bavtotAaNbDir);
  nomFormulaire.get('bavtotAaNbComptsecr').setValue(this.bavtotAaNbComptsecr);
  nomFormulaire.get('bavtotAaNbAutrSupport').setValue(this.bavtotAaNbAutrSupport);
  nomFormulaire.get('bavtotAaEtpAav').setValue(this.bavtotAaEtpAav);
  nomFormulaire.get('bavtotAaEtpJur').setValue(this.bavtotAaEtpJur);
  nomFormulaire.get('bavtotAaEtpPsy').setValue(this.bavtotAaEtpPsy);
  nomFormulaire.get('bavtotAaEtpWsoc').setValue(this.bavtotAaEtpWsoc);
  nomFormulaire.get('bavtotAaEtpAutrInterv').setValue(this.bavtotAaEtpAutrInterv);
  nomFormulaire.get('bavtotAaEtpDir').setValue(this.bavtotAaEtpDir);
  nomFormulaire.get('bavtotAaEtpComptsecr').setValue(this.bavtotAaEtpComptsecr);
  nomFormulaire.get('bavtotAaEtpAutrSupport').setValue(this.bavtotAaEtpAutrSupport);
  nomFormulaire.get('bavtotBbPremContactOrigAsso').setValue(this.bavtotBbPremContactOrigAsso);
  nomFormulaire.get('bavtotBbPremContactOrigPerso').setValue(this.bavtotBbPremContactOrigPerso);
  nomFormulaire.get('bavtotBbPremContactModeEcrit').setValue(this.bavtotBbPremContactModeEcrit);
  nomFormulaire.get('bavtotBbPremContactModeTel').setValue(this.bavtotBbPremContactModeTel);
  nomFormulaire.get('bavtotBbPremContactModePres').setValue(this.bavtotBbPremContactModePres);
  nomFormulaire.get('bavtotCcRecuVictNb').setValue(this.bavtotCcRecuVictNb);
  nomFormulaire.get('bavtotCcRecuVictSuivi').setValue(this.bavtotCcRecuVictSuivi);
  nomFormulaire.get('bavtotCcRecuVictEntret').setValue(this.bavtotCcRecuVictEntret);
  nomFormulaire.get('bavtotCcRecuNvictNb').setValue(this.bavtotCcRecuNvictNb);
  nomFormulaire.get('bavtotCcRecuNvictSuivi').setValue(this.bavtotCcRecuNvictSuivi);
  nomFormulaire.get('bavtotCcRecuNvictEntret').setValue(this.bavtotCcRecuNvictEntret);
  nomFormulaire.get('bavtotCcRecuVict').setValue(this.bavtotCcRecuVict);
  nomFormulaire.get('bavtotCcRecuVictPc').setValue(this.bavtotCcRecuVictPc);
  nomFormulaire.get('bavtotCcRecuVictAud').setValue(this.bavtotCcRecuVictAud);
  nomFormulaire.get('bavtotDdFaitPersoHomiVolo').setValue(this.bavtotDdFaitPersoHomiVolo);
  nomFormulaire.get('bavtotDdFaitPersoSexuel').setValue(this.bavtotDdFaitPersoSexuel);
  nomFormulaire.get('bavtotDdFaitPersoProxe').setValue(this.bavtotDdFaitPersoProxe);
  nomFormulaire.get('bavtotDdFaitPersoViolen').setValue(this.bavtotDdFaitPersoViolen);
  nomFormulaire.get('bavtotDdFaitPersoHomiInvolo').setValue(this.bavtotDdFaitPersoHomiInvolo);
  nomFormulaire.get('bavtotDdFaitPersoBless').setValue(this.bavtotDdFaitPersoBless);
  nomFormulaire.get('bavtotDdFaitPersoAband').setValue(this.bavtotDdFaitPersoAband);
  nomFormulaire.get('bavtotDdFaitPersoMenace').setValue(this.bavtotDdFaitPersoMenace);
  nomFormulaire.get('bavtotDdFaitPersoDiscri').setValue(this.bavtotDdFaitPersoDiscri);
  nomFormulaire.get('bavtotDdFaitPersoAutr').setValue(this.bavtotDdFaitPersoAutr);
  nomFormulaire.get('bavtotDdFaitBienVolSimp').setValue(this.bavtotDdFaitBienVolSimp);
  nomFormulaire.get('bavtotDdFaitBienVolAggr').setValue(this.bavtotDdFaitBienVolAggr);
  nomFormulaire.get('bavtotDdFaitBienEscro').setValue(this.bavtotDdFaitBienEscro);
  nomFormulaire.get('bavtotDdFaitBienDegrad').setValue(this.bavtotDdFaitBienDegrad);
  nomFormulaire.get('bavtotDdFaitBienAutr').setValue(this.bavtotDdFaitBienAutr);
  nomFormulaire.get('bavtotDdFaitCircuBless').setValue(this.bavtotDdFaitCircuBless);
  nomFormulaire.get('bavtotDdFaitCircuDegat').setValue(this.bavtotDdFaitCircuDegat);
  nomFormulaire.get('bavtotDdFaitAutr').setValue(this.bavtotDdFaitAutr);
  nomFormulaire.get('bavtotEeEntretPsy').setValue(this.bavtotEeEntretPsy);
  nomFormulaire.get('bavtotEeEntretJur').setValue(this.bavtotEeEntretJur);
  nomFormulaire.get('bavtotEeEntretSoc').setValue(this.bavtotEeEntretSoc);
  nomFormulaire.get('bavtotEeEntretEcout').setValue(this.bavtotEeEntretEcout);
  nomFormulaire.get('bavtotEeEntretAutr').setValue(this.bavtotEeEntretAutr);
  nomFormulaire.get('bavtotEeDiliJur').setValue(this.bavtotEeDiliJur);
  nomFormulaire.get('bavtotEeDiliCivi').setValue(this.bavtotEeDiliCivi);
  nomFormulaire.get('bavtotEeDiliFondGaran').setValue(this.bavtotEeDiliFondGaran);
  nomFormulaire.get('bavtotEeDiliSarvi').setValue(this.bavtotEeDiliSarvi);
  nomFormulaire.get('bavtotEeDiliPenit').setValue(this.bavtotEeDiliPenit);
  nomFormulaire.get('bavtotEeDiliPolgend').setValue(this.bavtotEeDiliPolgend);
  nomFormulaire.get('bavtotEeDiliAvoc').setValue(this.bavtotEeDiliAvoc);
  nomFormulaire.get('bavtotEeDiliHuis').setValue(this.bavtotEeDiliHuis);
  nomFormulaire.get('bavtotEeDiliOrgaSoc').setValue(this.bavtotEeDiliOrgaSoc);
  nomFormulaire.get('bavtotEeDiliColter').setValue(this.bavtotEeDiliColter);
  nomFormulaire.get('bavtotEeDiliPref').setValue(this.bavtotEeDiliPref);
  nomFormulaire.get('bavtotEeDiliOrgaLogt').setValue(this.bavtotEeDiliOrgaLogt);
  nomFormulaire.get('bavtotEeDiliHebgt').setValue(this.bavtotEeDiliHebgt);
  nomFormulaire.get('bavtotEeDiliHosto').setValue(this.bavtotEeDiliHosto);
  nomFormulaire.get('bavtotEeDiliAsso').setValue(this.bavtotEeDiliAsso);
  nomFormulaire.get('bavtotEeDiliAssur').setValue(this.bavtotEeDiliAssur);
  nomFormulaire.get('bavtotEeDiliSad').setValue(this.bavtotEeDiliSad);
  nomFormulaire.get('bavtotEeDiliFrserv').setValue(this.bavtotEeDiliFrserv);
  nomFormulaire.get('bavtotEeDiliAutr').setValue(this.bavtotEeDiliAutr);
  nomFormulaire.get('bavtotEeAideCivi').setValue(this.bavtotEeAideCivi);
  nomFormulaire.get('bavtotEeAideSarvi').setValue(this.bavtotEeAideSarvi);
  nomFormulaire.get('bavtotEeProcPreSentenPlainte').setValue(this.bavtotEeProcPreSentenPlainte);
  nomFormulaire.get('bavtotEeProcPreSentenEnq').setValue(this.bavtotEeProcPreSentenEnq);
  nomFormulaire.get('bavtotEeProcPreSentenCss').setValue(this.bavtotEeProcPreSentenCss);
  nomFormulaire.get('bavtotEeProcPreSentenPc').setValue(this.bavtotEeProcPreSentenPc);
  nomFormulaire.get('bavtotEeProcPreSentenAud').setValue(this.bavtotEeProcPreSentenAud);
  nomFormulaire.get('bavtotEeProcPreSentenAutr').setValue(this.bavtotEeProcPreSentenAutr);
  nomFormulaire.get('bavtotEeProcPostSentenDec').setValue(this.bavtotEeProcPostSentenDec);
  nomFormulaire.get('bavtotEeProcPostSentenDef').setValue(this.bavtotEeProcPostSentenDef);
  nomFormulaire.get('bavtotEeProcPostSentenRecour').setValue(this.bavtotEeProcPostSentenRecour);
  nomFormulaire.get('bavtotEeProcPostSentenAutr').setValue(this.bavtotEeProcPostSentenAutr);
  nomFormulaire.get('bavtotEeAuteurPreSentenCj').setValue(this.bavtotEeAuteurPreSentenCj);
  nomFormulaire.get('bavtotEeAuteurPreSentenDp').setValue(this.bavtotEeAuteurPreSentenDp);
  nomFormulaire.get('bavtotEeAuteurPreSentenFinDeten').setValue(this.bavtotEeAuteurPreSentenFinDeten);
  nomFormulaire.get('bavtotEeAuteurPreSentenFinMes').setValue(this.bavtotEeAuteurPreSentenFinMes);
  nomFormulaire.get('bavtotEeAuteurPreSentenAutr').setValue(this.bavtotEeAuteurPreSentenAutr);
  nomFormulaire.get('bavtotEeAuteurPostSentenMilFer').setValue(this.bavtotEeAuteurPostSentenMilFer);
  nomFormulaire.get('bavtotEeAuteurPostSentenMilOuv').setValue(this.bavtotEeAuteurPostSentenMilOuv);
  nomFormulaire.get('bavtotEeAuteurPostSentenFinDeten').setValue(this.bavtotEeAuteurPostSentenFinDeten);
  nomFormulaire.get('bavtotEeAuteurPostSentenFinMes').setValue(this.bavtotEeAuteurPostSentenFinMes);
  nomFormulaire.get('bavtotEeAuteurPostSentenAutr').setValue(this.bavtotEeAuteurPostSentenAutr);
  nomFormulaire.get('bavtotEeDiPreSentenCivi').setValue(this.bavtotEeDiPreSentenCivi);
  nomFormulaire.get('bavtotEeDiPreSentenAutr').setValue(this.bavtotEeDiPreSentenAutr);
  nomFormulaire.get('bavtotEeDiPostSentenCivi').setValue(this.bavtotEeDiPostSentenCivi);
  nomFormulaire.get('bavtotEeDiPostSentenSarvi').setValue(this.bavtotEeDiPostSentenSarvi);
  nomFormulaire.get('bavtotEeDiPostSentenHuis').setValue(this.bavtotEeDiPostSentenHuis);
  nomFormulaire.get('bavtotEeDiPostSentenJapSpip').setValue(this.bavtotEeDiPostSentenJapSpip);
  nomFormulaire.get('bavtotEeDiPostSentenFondGar').setValue(this.bavtotEeDiPostSentenFondGar);
  nomFormulaire.get('bavtotEeDiPostSentenAutr').setValue(this.bavtotEeDiPostSentenAutr);
  nomFormulaire.get('bavtotEeFoncJudic').setValue(this.bavtotEeFoncJudic);
  nomFormulaire.get('bavtotEeDemarPlainte').setValue(this.bavtotEeDemarPlainte);
  nomFormulaire.get('bavtotEeDemarAj').setValue(this.bavtotEeDemarAj);
  nomFormulaire.get('bavtotEeDemarAud').setValue(this.bavtotEeDemarAud);
  nomFormulaire.get('bavtotEeDemarAccomp').setValue(this.bavtotEeDemarAccomp);
  nomFormulaire.get('bavtotEeDemarDi').setValue(this.bavtotEeDemarDi);
  nomFormulaire.get('bavtotEeDemarAutr').setValue(this.bavtotEeDemarAutr);
  nomFormulaire.get('bavtotAaNbTot').setValue(this.bavtotAaNbTot);
  nomFormulaire.get('bavtotAaEtpTot').setValue(this.bavtotAaEtpTot);
  nomFormulaire.get('bavtotBbPremContactOrigTot').setValue(this.bavtotBbPremContactOrigTot);
  nomFormulaire.get('bavtotBbPremContactModeTot').setValue(this.bavtotBbPremContactModeTot);
  nomFormulaire.get('bavtotCcRecuNbTot').setValue(this.bavtotCcRecuNbTot);
  nomFormulaire.get('bavtotCcRecuSuiviTot').setValue(this.bavtotCcRecuSuiviTot);
  nomFormulaire.get('bavtotCcRecuEntretTot').setValue(this.bavtotCcRecuEntretTot);
  nomFormulaire.get('bavtotDdFaitPersoTot').setValue(this.bavtotDdFaitPersoTot);
  nomFormulaire.get('bavtotDdFaitBienTot').setValue(this.bavtotDdFaitBienTot);
  nomFormulaire.get('bavtotDdFaitCircuTot').setValue(this.bavtotDdFaitCircuTot);
  nomFormulaire.get('bavtotDdFaitTot').setValue(this.bavtotDdFaitTot);
  nomFormulaire.get('bavtotEeEntretTot').setValue(this.bavtotEeEntretTot);
  nomFormulaire.get('bavtotEeDiliTot').setValue(this.bavtotEeDiliTot);
  nomFormulaire.get('bavtotEeProcPreSentenTot').setValue(this.bavtotEeProcPreSentenTot);
  nomFormulaire.get('bavtotEeProcPostSentenTot').setValue(this.bavtotEeProcPostSentenTot);
  nomFormulaire.get('bavtotEeAuteurPreSentenTot').setValue(this.bavtotEeAuteurPreSentenTot);
  nomFormulaire.get('bavtotEeAuteurPostSentenTot').setValue(this.bavtotEeAuteurPostSentenTot);
  nomFormulaire.get('bavtotEeDiPreSentenTot').setValue(this.bavtotEeDiPreSentenTot);
  nomFormulaire.get('bavtotEeDiPostSentenTot').setValue(this.bavtotEeDiPostSentenTot);
  nomFormulaire.get('bavtotEeDemarTot').setValue(this.bavtotEeDemarTot);
}

public getListeAlertesFormulaire(formulaire: UntypedFormGroup): void {
  // Recuperation des alertes à partir des maps d'alertes de AlertesService
  this.listeAlertesForm = [];

  // dg
  this.alertesService.mapAlertesDG.forEach((valeur, key) => {
    if (valeur) {
      this.listeAlertesForm.push(key);
    }
  });
  // moyens
  this.alertesService.mapAlertesMoyens.forEach((valeur, key) => {
    if (valeur) {
      this.listeAlertesForm.push(key);
    }
  });
  // premiersContacts
  this.alertesService.mapAlertesPremiersContacts.forEach((valeur, key) => {
    if (valeur) {
      this.listeAlertesForm.push(key);
    }
  });
  // personnesRecues
  this.alertesService.mapAlertesPersonnesRecues.forEach((valeur, key) => {
    if (valeur) {
      this.listeAlertesForm.push(key);
    }
  });
  // contexteFaitsProcedure
  this.alertesService.mapAlertesContexteFaitsProcedure.forEach((valeur, key) => {
    if (valeur) {
      this.listeAlertesForm.push(key);
    }
  });
  // aidesApportees
  this.alertesService.mapAlertesAidesApportees.forEach((valeur, key) => {
    if (valeur) {
      this.listeAlertesForm.push(key);
    }
  });
  // bav
  this.alertesService.mapAlertesBav.forEach((valeur, key) => {
    if (valeur) {
      this.listeAlertesForm.push(key);
    }
  });

  formulaire.get('listeAlertesForm').setValue(this.listeAlertesForm);
}

}
